import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, TemplateRef, ChangeDetectorRef, ElementRef, ViewChild, HostBinding } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { Observable, Subscription, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatRadioChange } from '@angular/material/radio';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
// import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
//import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { TaskActionType } from 'src/app/middleware/common/allEnums.enum';
import { COMMA, E, ENTER, I, L } from '@angular/cdk/keycodes';
import { ModuleName, ProjectTempType } from '../../../../middleware/common/Enum/common.enum';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { AddCoreVm, CoreVm, FileModelVM } from 'src/app/viewModels/core/core-vm';
import { addDays } from '@fullcalendar/angular';
import { value } from 'src/app/applicationModules/eSignature/global.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { ThrowStmt } from '@angular/compiler';
import { ImportForm3CListComponent } from 'src/app/middleware/common/importForm3C/importForm3C.component';
import { AddSelectParticipantComponent } from 'src/app/middleware/common/addselectParticipant/addselectParticipant.component';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}


@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.scss'],
  providers: [DatePipe]
})
export class TaskDetailsComponent implements OnInit {

  // This panel is shared. On /core/documents it opens below the record header,
  // so it needs a different offset there; the class drives that in the stylesheet.
  @HostBinding('class.inCoreDocuments')
  get isCoreDocumentsScreen(): boolean {
    const path = (this.router.url || '').split(/[?#]/)[0].replace(/\/+$/, '');
    return path === '/core/documents';
  }

  selectedValue: Number = 2;
  panelState: boolean;
  notificationdays = [
    {
      "id": "days",
      "name": "days"
    }
    // {
    //     "id": "days",
    //     "name": "weeks"   
    // },
  ]

  colors = [
    {
      colname: '#F5D428'
    },
    {
      colname: '#6FC040'
    },
    {
      colname: '#52A7F9'
    },
    {
      colname: '#EF8F1E'
    },
    {
      colname: '#EC5C58'
    },
    {
      colname: '#B36AE2'
    },
    {
      colname: '#a59f9f'
    }
  ]
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  IsCustomFieldExist: boolean = false;
  close: boolean = false;
  SubTask: boolean = false;
  PI: boolean = true;
  showSub: boolean = false;
  showTaskOption: any
  selectedTaskOpt: any
  showAssignedTask = false;
  showReminderTask = false;
  showScheduleTask = false;
  showAttachTask = false;
  dialogRef: MatDialogRef<any, any>;
  @Output() closeTaskDetail = new EventEmitter<boolean>();
  @Output() closeSaveTaskDetail = new EventEmitter<boolean>();
  @Output() showPI = new EventEmitter<boolean>();

  //@Input() selectedTaskOption : any;
  @Input() taskId: number;
  @Input() showAddGroupButton: boolean;
  @Input() taskListID: number = 0;
  myTaskForm: FormGroup;
  tabType: number = 0;
  taskComplete: boolean = false;
  taskDetailList: any = [] = [];

  showColorPannel = false;
  selectedColor: string = '#db241c';

  contactsList: any = [];
  timeout = null;
  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;
  stateCtrl = new FormControl();
  scheduledTaskCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  //roleInputCurrentvalue:any;
  stateCtrSendlValue: any;
  stateCtrlValue: string;
  objectList: any = [];
  contactemail: any;
  anonymousEmail: any = [] = [];
  addEmailButtonShow: boolean = false;
  selectedContacts: any = [] = [];

  selectedAssignedTo: any = [] = [];

  ShowContactBox: boolean = false;
  ShowRoleBox: boolean = false;
  ShowEmailBox: boolean = false;
  ShowUserBox: boolean = false;
  ContactName: string = "";
  spinner: boolean = false;
  ImagePathURL: string = '';
  showTaskUpdateButton: boolean = false;

  getTaskAssignedEntityInDetails: any = [] = [];
  getTaskAttachedEntityInDetails: any = [] = [];
  checkedContact: boolean = false;
  checkedRole: boolean = false;
  checkedRelationShip: boolean = false;
  checkedEmail: boolean = false;
  checkedUser: boolean = false;
  menuModulesList: any = [] = [];

  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  UploadedFilesDragZone: any[];
  formData: FormData;
  allSubTask: any = [] = [];

  filterTypes = [
    'Open',
    'In Progress',
    'Blocked',
    'Completed',
    'Declined'
  ];

  dynamicForm: FormGroup;
  dynamicFormNotification: FormGroup;
  dynamicFormNotificationEmail: FormGroup;
  documentFolders: any = [];
  selectedFolderID: any = 0;
  taskStatusList: any = [];
  statusID: any = 0;
  isAssignedEntity: boolean;
  preorityID: any = 0;
  contactsVm: any;
  NormalContacts: any = [];
  SharedContacts: any = [];
  companysVm: any;
  NormalCompanys: any = [];
  relationShips: any = [];
  ShowRelationshipBox: boolean = false;
  selectedUIRelationship: any = [];
  resultUIRelationship: any = [];
  ModuleName: any;
  folderID: any;
  coreFieldSaveCompareForType: any = [];
  coreFieldListForType: any = [];
  myFormGroup: FormGroup;
  transactionUserName: any;
  transactionUserRole: any;
  addressFormGroup: any = [];
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  addressValue: any;
  cityValue: any;
  stateValue: any;
  zipValue: any;
  grpToggle: boolean = true;
  checkboxStatus: boolean = false;
  coreFieldList: any;
  coreFieldSaveCompare: any;
  coreFieldListSubmit: any;
  ImageUploadURL: any = '';
  imagelist: any;
  dropdownlist: any = [] = [];
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;

  chkStatusArry: any;
  imageSrc: string = '';
  FileName: any;
  FileExtention: any;
  Base64String: any;
  @Output() closeAdd = new EventEmitter<boolean>();
  tempValue: any;
  TypeList: any = [];
  step = 0;


  AllTypeList: any = [];
  selectedTypeList: any;

  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  getSubFolderFieldsListResponseHolder: any;
  getTagListResponseHolder: any;
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0
  };
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize: 0,
    OfficeIDList: [],
    officeID: 0
  };
  CityModel = {
    Name: '',
    databaseID: 0,
    userID: ''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID: ''
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];


  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  cityOption: string[] = [];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[] = [];
  allTags: string[] = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('Input') InputFile: ElementRef;
  //@ViewChild('repeatTaskFieldId') repeatTaskFieldId: ElementRef;
  @ViewChild('repeatTaskFieldId') selectElement: MatSelect;
  clickEventsubscription: Subscription;
  arryaControlNameIdpare: any = [];
  tagvalues: string = '';
  zipOption: any = [];
  stateList: any = [];
  selectedFieldValue: any = 10433;
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  coreUserList: any;
  transactionID: number = 0;
  isTypeChanged: boolean = false;
  TypeIdDrp: number = 0;
  arrayControlNameSubfolderID: any = [];
  dynamicArrayEdit: any;
  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;
  emptyArrya: any = [];
  taskListName: string = "";

  public showSpinners = true;
  currentFormLinkFormName: any = '';
  @Input() mainModulename: string = '';
  @Input() SingleTaskArchived: boolean = false;
  @Input() showAddGroupButtonCore: boolean = false;

  repeatTaskEmail: string = "";
  EmailTemplate: string = "";
  showRepeatTaskEmail: boolean = false;
  showRepeatTaskForCCC: boolean = false;
  addByEmail: string = "";
  addByName: string = "";
  disableFormLink: boolean = false;
  projectID: number = 0;
  projectLink: string = "";
  taskActionType: Number = 1;
  clickEventsubscriptionListRefreshList: any;
  LoggedInEmailId: string = "";

  /* ---- Section tabs (Action / Attach / Assign / Repeat / Notify) ---- */
  sectionTabs: { id: string; label: string; title: string; icon: string }[] = [
    { id: 'action', label: 'Action', title: 'Action Type', icon: 'flash_on' },
    { id: 'attach', label: 'Attach', title: 'Attach To', icon: 'attach_file' },
    { id: 'assign', label: 'Assign', title: 'Assigned To', icon: 'person_outline' },
    { id: 'repeat', label: 'Repeat', title: 'Schedule Repeating Task', icon: 'autorenew' },
    { id: 'notify', label: 'Notify', title: 'Setup Email Notification', icon: 'notifications_none' }
  ];
  activeSectionTab: string = 'action';

  constructor(private datePipe: DatePipe, private dialog: MatDialog, private loaderService: LoaderService,
    private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
    private router: Router, private reusableClass: ReusableClasses, private coreVm: CoreVm,
    private encryptionAlgo: EncryptionService, private statusConst: StatusConstant,
    private coreService: CoreService, private formBuilder: FormBuilder, private fileModelVM: FileModelVM, private addCoreVm: AddCoreVm,
    private toastr: ToastrService, private settingsService: SettingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    this.LoggedInEmailId = sessionStorage.getItem('email') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') || '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }



  ngOnInit(): void {
    this.taskActionType = TaskActionType.Any;

    let menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    let Module = [];
    Module = menuModulesList.filter((x: any) => (x.mainModuleName.toLowerCase() == "Task".toLowerCase()) || (x.mainModuleName.toLowerCase() == "New Task".toLowerCase()));
    if (Module.length > 0) {
      this.ModuleName = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
    }

    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.coreFieldSaveCompareForType = [];
    this.coreFieldListForType = [];
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.getAllTagsList();
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.getStateDropdownList(231);
    this.getEmailTemplateList();
    this.clickEventsubscriptionListRefreshList = this._dataSharingService.getRefreshListAfterAddingParticipant().
      subscribe((result) => {
        if (result) {
          this.getTaskDetailByID();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.SingleTaskArchived;
    var ModuleName = this.mainModulename;
    if (ModuleName != "Task") {
      this.showAddGroupButton = false;
      this.showRepeatTaskForCCC = true;
    }

    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }
    this.showAddGroupButtonCore;
    if (this.showAddGroupButtonCore == true) {
      this.showAddGroupButton = true;
    }
    this.SingleTaskArchived = false;

    this.taskId;
    if (this.taskId > 0) {
      let group = {};
      this.myTaskForm = new FormGroup(group);
      this.dynamicForm = this.formBuilder.group({
        filters: this.formBuilder.array([])
      });

      this.dynamicFormNotification = this.formBuilder.group({
        filtersmNotification: this.formBuilder.array([])
      });

      this.dynamicFormNotificationEmail = this.formBuilder.group({
        filtersmNotificationEmail: this.formBuilder.array([])
      });

      this.repeatTaskEmail = "";
      this.EmailTemplate = "";
      this.createFormTask();

      this.getTaskStatus();
      if (this.taskListID == 0 || this.taskListID == undefined) {
        this.getTaskStatusForSchedule();
      }
      if (this.taskListID > 0) {
        this.getTaskStatusForSchedule1();
      }
    }
  }

  ngOnDestroy() {
    this.clickEventsubscriptionListRefreshList.unsubscribe();
  }

  setSelectedOption(option: any) {
    this.selectElement.value = this.selectedFieldValue;
  }

  settab(i: any) {
    this.tabType = i.index;  // 1 for task two for custom fields
  }

  getTaskStatus() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusList = this.responseHolder.data;
        } else {
          this.taskStatusList = [];
        }
      } else {
        this.taskStatusList = [];
      }
    });

  }

  //========= For Subtask ============//

  createFilterGroup() {
    return this.formBuilder.group({
      taskId: 0,
      filterType: [],
      taskTitle: '',
      status: 0
    });
  }

  createFilterGroupNotification() {
    return this.formBuilder.group({
      // taskId: 0,
      // filterType: [],
      timePeriodNumber: '',
      timePeriodName: 'days'
    });
  }

  createFilterGroupNotificationEmail() {
    return this.formBuilder.group({
      templateID: 0,
      number: '',
      period: 'days'
    });
  }

  addFilterToFiltersFormArray() {
    this.filtersFormArray.push(this.createFilterGroup());
  }

  addFilterToFiltersFormArrayNotification() {
    if (this.filtersFormArrayNotification.value.length <= 4) {
      this.filtersFormArrayNotification.push(this.createFilterGroupNotification());
      this.showRepeatTaskEmail = true;
    }
  }

  addFilterToFiltersFormArrayNotificationEmail() {
    if (this.filtersFormArrayNotificationEmail.value.length <= 4) {
      this.filtersFormArrayNotificationEmail.push(this.createFilterGroupNotificationEmail());
      this.showRepeatTaskEmail = true;
    }
  }

  removeFilterFromFiltersFormArray(index: any, filter: any) {
    if (filter.taskId > 0) {
      this.deleteSubTask(filter.taskId);
    }
    this.filtersFormArray.removeAt(index);
    this.showTaskUpdateButton = true;
  }

  removeFilterFromFiltersFormArrayNotification(index: any, filter: any) {
    this.filtersFormArrayNotification.removeAt(index);
    if (this.filtersFormArrayNotification.value.length == 0) {
      this.showRepeatTaskEmail = false;
    }
    this.showTaskUpdateButton = true;
  }

  removeFilterFromFiltersFormArrayNotificationEmail(index: any, filter: any) {
    this.filtersFormArrayNotificationEmail.removeAt(index);
    if (this.filtersFormArrayNotificationEmail.value.length == 0) {
      this.showRepeatTaskEmail = false;
    }
    this.showTaskUpdateButton = true;
  }

  getFormControl() {
    return this.formBuilder.control(null);
  }

  get filtersFormArray() {
    return (<FormArray>this.dynamicForm.get('filters'));
  }

  get filtersFormArrayNotification() {
    return (<FormArray>this.dynamicFormNotification.get('filtersmNotification'));
  }

  get filtersFormArrayNotificationEmail() {
    return (<FormArray>this.dynamicFormNotificationEmail.get('filtersmNotificationEmail'));
  }

  /* ---- Section tabs helpers ---- */
  setSectionTab(tabId: string) {
    if (this.activeSectionTab === tabId) {
      return;
    }
    this.activeSectionTab = tabId;
    // Nested mat-tab-group / mat-expansion-panel measure themselves on layout,
    // so nudge them once the pane is actually visible.
    setTimeout(() => {
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) { }
    });
  }

  isSectionTabFilled(tabId: string): boolean {
    switch (tabId) {
      case 'action':
        return Number(this.taskActionType) > 1;
      case 'attach':
        return this.hasAttachedEntity();
      case 'assign':
        return this.selectedAssignedTo && this.selectedAssignedTo.length > 0;
      case 'repeat':
        return this.showAddGroupButton === true;
      default:
        return false;
    }
  }

  hasAttachedEntity(): boolean {
    const hasLive = (list: any) =>
      !!list && list.length > 0 && list.some((e: any) => !e || e.isDeleted !== true);
    return hasLive(this.attachedToSelectedCore)
      || hasLive(this.attachedToSelectedContact)
      || hasLive(this.attachedToSelectedCompany);
  }

  sectionTabCount(tabId: string): number {
    if (tabId === 'notify') {
      if (!this.dynamicFormNotification) {
        return 0;
      }
      const arr = this.filtersFormArrayNotification;
      return arr ? arr.length : 0;
    }
    return 0;
  }


  deleteSubTask(subtaskId: any) {
    this.loaderService.show();
    var reqModel = {
      taskId: Number(this.taskId),
      subTaskIds: [subtaskId],
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.coreService.removeSubTasks(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Sub Task deleted successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getFormLink(event: any) {
    if (event.value) {
      this.taskActionType = event.value;
    } else {
      this.taskActionType = TaskActionType.Any;
    }
    this.showTaskUpdateButton = true;

    // Check for Email Template
    if (this.taskActionType == Number("6")) {
      this.getOfficeMailConfigration();
    }
  }

  disabledEmailNotification: boolean = false

  getOfficeMailConfigration() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID
    };
    this.settingsService.getOfficeMailConfigration(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.eMailConfigeType == 0) {
            this.disabledEmailNotification = true;
          } else {
            this.disabledEmailNotification = false;
          }
        }
      } else {

      }
    });
  }

  setFormURL() {
    let formURL = this.myTaskForm.get('formLink').value;
    if (formURL !== '' && formURL != null && formURL != undefined) {
      const getToken = formURL.split("token=")[1];
      if (getToken !== undefined) {
        const params = decodeURIComponent(getToken);
        const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
        const decryptedToken = JSON.parse(encrptedToken)
        decryptedToken.taskID = this.taskId
        const jsonString = JSON.stringify(decryptedToken)
        const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
        const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
        const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
        this.myTaskForm.controls['formLink'].setValue(finalFormURL);
        this.GetFormDetailsByFormID(decryptedToken.FormID);
      }
    }
    else {
      this.currentFormLinkFormName = '';
    }
    this.showTaskUpdateButton = true;
  }

  GetFormDetailsByFormID(projectID: any) {
    var ReqModel = {
      projectID: Number(projectID),
      type: 2,// 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    };
    this.loaderService.show();
    this.settingsService.GetFormDetailsByFormID(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.project != null) {
            this.currentFormLinkFormName = this.responseHolder.data.project.projectName;
            this.myTaskForm.controls['formLinkFormName'].setValue(this.responseHolder.data.project.projectName);
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  openFormURL() {
    if (this.projectID == 0) {
      let url = this.myTaskForm.get('formLink').value;
      if (url != null && url != "" && url != undefined) {
        if (url.substring(0, 4) == 'http') {
          window.open(url, '_blank');
        } else {
          window.open('https://' + url, '_blank');
        }
      }
    }
  }


  openSignNowURL() {
    let url = this.signNowUrl;
    if (url != null && url != "" && url != undefined) {
      if (url.substring(0, 4) == 'http') {
        window.open(url, '_blank');
      } else {
        window.open('https://' + url, '_blank');
      }
    }
  }

  viewProject() {
    if (this.projectID > 0) {
      let url = this.projectLink;
      if (url != null && url != "" && url != undefined) {
        let URL = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + url + "&IsReadOnlyFromsignaturePage=true" + "&signnowFrom=" + encodeURIComponent(this.LoggedInEmailId);
        window.open(URL, '_blank');
      }
    }
  }

  resetProject() {
    sessionStorage.setItem('projectID', String(this.projectID));
    sessionStorage.setItem('stepCompleted', '0');
    sessionStorage.setItem('type', (ProjectTempType.Project).toString());
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('isSent', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    this.router.navigate(['/esignature/first']);
  }

  createFormTask(): void {
    this.myTaskForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      startDate: [''],
      dueDate: [''],
      description: [''],
      isRequired: [false],
      //dueDate: ['', [Validators.required]],
      selectedTaskActionType: ['', [Validators.required]],
      selectedFolderctrl: ['', [Validators.required]],
      formLink: ['', [Validators.required]],
      formLinkFormName: [''],
      isInternal: ['', [Validators.required]],
      isDueDateTrigger: ['', null],
      isDueOnFieldBased: ['', null],
      taskStatus: ['', [Validators.required]],
      preorityID: ['', [Validators.nullValidator]],
      triggerstatus: ['',],
      triggertask: ['',],
      timenumber: [null, [Validators.min(0), Validators.max(99), Validators.minLength(0), Validators.maxLength(2)]],
      timeperiod: ['',],
      afterbefore: ['',],
      repeatEvery: [1, [Validators.min(0), Validators.max(99), Validators.minLength(0), Validators.maxLength(2)]],
      repeatType: ['',],
      repeatEnds: ['',],
      monthDay: [''],
      yearDay: [''],
      yearMonth: [''],
      EndsOnDate: [''],
      occurances: [''],
      repeatTaskEmail: [],
      emailTemplate: [],
      repeatTaskFieldId: [0],
      specificDay: ['']
    },);
  }

  createFormTaskSchedule(): void {
    this.myTaskForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      description: [''],
      startDate: [''],
      dueDate: [''],
      // dueDate: ['', [Validators.required]],
      selectedTaskActionType: ['', [Validators.required]],
      selectedFolderctrl: ['', [Validators.required]],
      formLink: ['', [Validators.required]],
      formLinkFormName: [''],
      isInternal: ['', [Validators.required]],
      isDueDateTrigger: ['', null],
      taskStatus: ['', [Validators.required]],
      preorityID: ['', [Validators.nullValidator]],
      triggerstatus: ['',],
      triggertask: ['',],
      timenumber: [0, [Validators.min(0), Validators.max(99), Validators.minLength(0), Validators.maxLength(2)]],
      timeperiod: ['',],
      afterbefore: ['',],
    },);
  }

  async selectFilesFromDragZone(event: any) {

    if (this.taskActionType == 3 || this.taskDetailList.action == 3) {

      if (
        this.attachedToSelectedCore.length > 0 ||
        this.attachedToSelectedContact.length > 0 ||
        this.attachedToSelectedCompany.length > 0
      ) {

        if (
          this.taskDetailList.documentFolderID == 0 &&
          this.selectedFolderID == 0
        ) {

          event.target.value = '';
          this.toastr.warning(
            'Select document folder to upload document'
          );
          return;

        }

      }

    }

    this.showTaskUpdateButton = true;
    this.loaderService.show();

    this.formData = new FormData();
    this.UploadedFilesDragZone = event.target.files;

    const maxFileSize = 20 * 1024 * 1024; //20 MB
    const invalidCharsRegex = /[ #?%+&:;@="<>\\|^`{}\[\]]/g;

    const cleanedFiles: any[] = [];

    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {

      const file = this.UploadedFilesDragZone[i];

      if (!file) {
        continue;
      }

      //=========================
      // FILE SIZE
      //=========================

      if (file.size > maxFileSize) {

        const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

        this.toastr.warning(
          `"${file.name}" is ${sizeInMB} MB. Maximum allowed file size is 20 MB.`,
          '',
          {
            timeOut: 9000
          }
        );

        continue;
      }

      //=========================
      // PDF PASSWORD CHECK
      //=========================

      if (file.type === 'application/pdf') {

        const isPasswordProtected = await new Promise<boolean>((resolve) => {

          const reader = new FileReader();

          reader.onload = (e: any) => {

            try {

              const uint8Array = new Uint8Array(e.target.result);

              const pdfText = new TextDecoder().decode(uint8Array);

              resolve(pdfText.includes('/Encrypt'));

            }
            catch {

              resolve(false);

            }

          };

          reader.onerror = () => resolve(false);

          reader.readAsArrayBuffer(file);

        });

        if (isPasswordProtected) {

          this.toastr.warning(
            `"${file.name}" is password protected and cannot be processed. Please upload a new file without a password.`,
            '',
            {
              timeOut: 9000
            }
          );

          continue;
        }

      }

      //=========================
      // FILE NAME
      //=========================

      const originalFileName = file.name;

      const lastDotIndex = originalFileName.lastIndexOf('.');

      if (lastDotIndex === -1) {

        this.toastr.warning(
          `Invalid file format: "${originalFileName}".`,
          '',
          {
            timeOut: 3000
          }
        );

        continue;

      }

      let nameWithoutExt = originalFileName.substring(0, lastDotIndex);

      const extension = originalFileName
        .substring(lastDotIndex + 1)
        .toLowerCase();

      let cleanedName = nameWithoutExt.replace(
        invalidCharsRegex,
        ''
      );

      cleanedName = cleanedName.replace(/\s+/g, '');

      if (!cleanedName) {

        this.toastr.warning(
          `Invalid file name after cleanup: "${originalFileName}".`,
          '',
          {
            timeOut: 3000
          }
        );

        continue;

      }

      if (cleanedName.length > 120) {

        this.toastr.warning(
          'File name upto 120 characters only supported, please rename file.',
          '',
          {
            timeOut: 3000
          }
        );

        continue;

      }

      const cleanedFile = new File(
        [file],
        `${cleanedName}.${extension}`,
        {
          type: file.type
        }
      );

      cleanedFiles.push({
        file: cleanedFile,
        documentName: cleanedName,
        documenttype: extension
      });

    }

    //=========================
    // NO VALID FILES
    //=========================

    if (cleanedFiles.length === 0) {

      this.loaderService.hide();
      this.UploadedFilesDragZone = [];
      event.target.value = '';

      return;

    }

    //=========================
    // APPEND FILES
    //=========================

    cleanedFiles.forEach(file => {

      this.formData.append('files', file.file);

      this.formData.append(
        'DocumentDetails',
        `${file.documenttype}|0|1|${file.documentName}`
      );

    });

    this.formData.append(
      'TaskID',
      this.taskId.toString()
    );

    this.formData.append(
      'DocumentFolderID',
      this.selectedFolderID > 0
        ? this.selectedFolderID
        : this.taskDetailList.documentFolderID
    );

    this.formData.append(
      'UserID',
      this.currentUser.UID
    );

    this.formData.append(
      'OrganizationID',
      this.organizationId
    );

    this.formData.append(
      'OfficeID',
      this.myOfficeID
    );

    this.formData.append(
      'DatabaseID',
      this.databaseId
    );

    let request: any;

    if (
      this.entityTypeAttached === 0 ||
      (
        this.taskDetailList.documentFolderID == 0 &&
        this.selectedFolderID == 0
      )
    ) {

      this.formData.append('TransactionID', '0');

      request = this.coreService.AddTaskMultiDocument(this.formData);

    }
    else if (this.entityTypeAttached === 1) {

      const coreId =
        this.attachedToSelectedCore.length > 0
          ? this.attachedToSelectedCore[0].coreID
          : this.taskDetailList.taskAttachedEntity.length > 0
            ? this.taskDetailList.taskAttachedEntity[0].attachedEntityID
            : 0;

      if (!coreId) {

        this.loaderService.hide();

        this.toastr.warning(
          'Please attach an entity to upload document'
        );

        return;

      }

      this.formData.append(
        'TransactionID',
        coreId.toString()
      );

      request = this.coreService.AddCoreMultiDocument(this.formData);

    }
    else if (this.entityTypeAttached === 2) {

      const contactId =
        this.attachedToSelectedContact.length > 0
          ? this.attachedToSelectedContact[0].contactID
          : this.taskDetailList.taskAttachedEntity.length > 0
            ? this.taskDetailList.taskAttachedEntity[0].attachedEntityID
            : 0;

      if (!contactId) {

        this.loaderService.hide();

        this.toastr.warning(
          'Please attach an entity to upload document'
        );

        return;

      }

      this.formData.append(
        'TransactionID',
        contactId.toString()
      );

      request = this.coreService.AddContactMultiDocument(this.formData);

    }
    else {

      const companyId =
        this.attachedToSelectedCompany.length > 0
          ? this.attachedToSelectedCompany[0].companyID
          : this.taskDetailList.taskAttachedEntity.length > 0
            ? this.taskDetailList.taskAttachedEntity[0].attachedEntityID
            : 0;

      if (!companyId) {

        this.loaderService.hide();

        this.toastr.warning(
          'Please attach an entity to upload document'
        );

        return;

      }

      this.formData.append(
        'TransactionID',
        companyId.toString()
      );

      request = this.coreService.AddCompanyMultiDocument(this.formData);

    }

    request.subscribe({

      next: (response: any) => {

        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        event.target.value = '';

        if (response) {

          this.responseHolder = response;

          if (
            this.responseHolder.status ===
            this.statusConst.statusSuccess
          ) {

            const uploadedDocuments =
              response.data?.taskAttached3CMappings?.[0];

            if (uploadedDocuments) {
              this.allUploadedDocuments.push(uploadedDocuments);
            }

            this.toastr.success(
              'File uploaded successfully.',
              '',
              {
                timeOut: 3000
              }
            );

          }
          else {

            this.toastr.error(
              'File Upload failed.',
              '',
              {
                timeOut: 3000
              }
            );

          }

        }

      },

      error: () => {

        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        event.target.value = '';

        this.toastr.error(
          'File Upload failed.',
          '',
          {
            timeOut: 3000
          }
        );

      }

    });

  }



  checkpdfPasswordProtected(file: File): Observable<any> {
    const reader = new FileReader();
    return new Observable(observer => {
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const byteArray = Array.from(new Uint8Array(arrayBuffer));
        this.coreService.canThisPdfOpenforModifyByBytes(byteArray).subscribe({
          next: (res) => {
            observer.next(res);
            observer.complete();
          },
          error: (err) => observer.error(err)
        });
      };

      reader.onerror = (err) => observer.error(err);

      reader.readAsArrayBuffer(file);
    });
  }

  allUploadedDocuments: any = []
  isAttachEntity = false;

  getAttached3c(event: any) {
    if (event.checked == true) {
      this.isAttachEntity = true;
    } else {
      this.isAttachEntity = false;
      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;
    }
    this.showTaskUpdateButton = true;
  }

  getAssigned3c(event: any) {
    if (event.checked == true) {
      this.isAssignedEntity = true
    } else {
      this.isAssignedEntity = false;
      this.entityTypeAssignee = 0;
      this.checkedRole = false;
      this.checkedRelationShip = false;
      this.checkedUser = false;
      this.checkedContact = false;
      this.checkedEmail = false;
    }
    this.showTaskUpdateButton = true;
  }

  onChangeDueDate(v: any, e: any) {
  }

  getNormalAndSharedCompanys(CoreID: any) {
    this.companysVm = {
      DatabaseID: 0,
      OrganizationID: 0,
      UserID: "",
      CoreID: 0,
      OfficeID: 0
    };
    this.companysVm.DatabaseID = Number(this.databaseId);
    this.companysVm.OrganizationID = Number(this.organizationId);
    this.companysVm.UserID = this.currentUser.UID;
    this.companysVm.CoreID = Number(CoreID);
    this.companysVm.OfficeID = this.myOfficeID;
    this.loaderService.show();
    this.settingsService.getNormalAndSharedCompanys(this.companysVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalCompanys = response.data.companyListModel;
          this.NormalCompanys.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.companyCoreRoleMappingModels !== null) {
              e.companyCoreRoleMappingModels.forEach((et: any) => {
                this.relationShips.push({
                  type: 'company',
                  id: e.companyID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                });
              });
            }
          });
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }


  getNormalAndSharedContacts(CoreID: any) {
    this.contactsVm = {
      DatabaseID: 0,
      OrganizationID: 0,
      UserID: "",
      CoreID: 0,
      OfficeID: 0
    };
    this.contactsVm.DatabaseID = Number(this.databaseId);
    this.contactsVm.OrganizationID = Number(this.organizationId);
    this.contactsVm.UserID = this.currentUser.UID;
    this.contactsVm.CoreID = Number(CoreID);
    this.loaderService.show();
    this.settingsService.getNormalAndSharedContacts(this.contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalContacts = response.data.contactListModel;
          this.SharedContacts = response.data.sharedContactListModel;
          this.NormalContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactCoreRoleMappingModels !== null) {
              e.contactCoreRoleMappingModels.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.SharedContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactCoreRoleMappingModels !== null) {
              e.contactCoreRoleMappingModels.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  GetContactSelectedContact(ContactID: any) {
    let contactsVm = {
      DatabaseID: 0,
      OrganizationID: 0,
      UserID: "",
      ContactID: 0,
      OfficeID: 0
    };
    contactsVm.DatabaseID = Number(this.databaseId);
    contactsVm.OrganizationID = Number(this.organizationId);
    contactsVm.UserID = this.currentUser.UID;
    contactsVm.ContactID = Number(ContactID);
    this.loaderService.show();
    this.settingsService.GetContactSelectedContact(contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalContacts = response.data.contactListModel;
          this.SharedContacts = response.data.sharedContactListModel;
          this.NormalContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactContactRoleMappingModel !== null) {
              e.contactContactRoleMappingModel.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.SharedContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactContactRoleMappingModel !== null) {
              e.contactContactRoleMappingModel.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  GetCompanySelectedContact(CompanyID: any) {
    let contactsVm = {
      DatabaseID: 0,
      OrganizationID: 0,
      UserID: "",
      CompanyID: 0,
      OfficeID: 0
    };
    contactsVm.DatabaseID = Number(this.databaseId);
    contactsVm.OrganizationID = Number(this.organizationId);
    contactsVm.UserID = this.currentUser.UID;
    contactsVm.CompanyID = Number(CompanyID);
    this.loaderService.show();
    this.settingsService.GetCompanySelectedContact(contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalContacts = response.data.contactListModel;
          this.SharedContacts = response.data.sharedContactListModel;
          this.NormalContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactCompanyRoleMappingModels !== null) {
              e.contactCompanyRoleMappingModels.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.SharedContacts.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
            if (e.contactCompanyRoleMappingModels !== null) {
              e.contactCompanyRoleMappingModels.forEach((et: any) => {
                this.relationShips.push({
                  type: 'contact',
                  id: e.contactID,
                  name: e.name,
                  email: e.email,
                  rloeName: et.rloeName,
                  transctionalRoleID: et.transctionalRoleID,
                  ImageUrl: e.imageUrl
                });
              });
            }
          });
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }


  getTaskDetailByID() {
    this.showTaskUpdateButton = false;
    this.loaderService.show();
    var ReqModel = {
      taskID: this.taskId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.coreService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.taskDetailList = [];
        this.allUploadedDocuments = [];
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.repeatTaskEmail = "";
          this.taskDetailList = response.data;
          this.projectID = response.data.projectID;
          this.projectLink = response.data.projectLink;
          this.IsCustomFieldExist = response.data.isCustomFieldExist;
          this.TypeIdDrp = (response.data.subFolderID != undefined && response.data.subFolderID != null && response.data.subFolderID != '') ? Number(response.data.subFolderID) : 0;
          this.myTaskForm.controls['title'].setValue(this.taskDetailList.title);
          this.myTaskForm.controls['description'].setValue(this.taskDetailList.description);
          // this.myTaskForm.controls['dueDate'].setValue(this.datePipe.transform(this.taskDetailList.dueDate+ "Z", "yyyy-MM-dd"));
          // this.myTaskForm.controls['dueDate'].setValue(this.datePipe.transform(this.taskDetailList.dueDate+ "Z", "MM/dd/yyyy"));
          if (this.taskDetailList.isRequired != null) {
            this.myTaskForm.controls['isRequired'].setValue(this.taskDetailList.isRequired);
          }
          if (this.taskDetailList.dueDate != null) {
            this.taskDetailList.dueDate = moment(this.taskDetailList.dueDate).local().format('YYYY-MM-DD');
            this.taskDetailList.dueDate = this.taskDetailList.dueDate + 'T12:00:00.000Z';

            //this.taskDetailList.dueDate=moment(this.taskDetailList.dueDate).local().format('YYYY-MM-DD');
            // this.taskDetailList.dueDate=this.taskDetailList.dueDate+'.000Z';

            this.myTaskForm.controls['dueDate'].setValue(this.taskDetailList.dueDate);
            this.originalDueDate = this.taskDetailList.dueDate;
            // const d = new Date(this.taskDetailList.dueDate);
            // // This will return an ISO string matching your local time.
            // var dueDateNew= new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
            // this.myTaskForm.controls['dueDate'].setValue(dueDateNew);
            // this.originalDueDate = dueDateNew;
            // var newDate = new Date(dueDateNew);
            // newDate.setDate(newDate.getDate() -1);
            // this.dueDatecheck = newDate;
            //dueDateNew.setDate(dueDateNew.getDate() +1);
            // this.myTaskForm.controls['dueDate'].setValue(this.taskDetailList.dueDate);
          } else {
            this.myTaskForm.controls['dueDate'].setValue(this.taskDetailList.dueDate);
            this.originalDueDate = this.taskDetailList.dueDate;
            //this.dueDatecheck = this.taskDetailList.dueDate;
          }

          if (this.taskDetailList.startDate != null) {
            // const d = new Date(this.taskDetailList.startDate);
            // // This will return an ISO string matching your local time.
            // var startDateNew= new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
            this.taskDetailList.startDate = moment(this.taskDetailList.startDate).local().format('YYYY-MM-DD');
            this.taskDetailList.startDate = this.taskDetailList.startDate + 'T12:00:00.000Z';

            this.myTaskForm.controls['startDate'].setValue(this.taskDetailList.startDate);
          } else {
            this.myTaskForm.controls['startDate'].setValue(this.taskDetailList.startDate);
          }

          this.myTaskForm.controls['preorityID'].setValue(this.taskDetailList.priority.toString());
          if (this.taskDetailList.isInternal == true) {
            this.myTaskForm.controls['isInternal'].setValue(false);
          } else {
            this.myTaskForm.controls['isInternal'].setValue(true);
          }
          if (this.taskDetailList.isDueDateTrigger == true) {
            this.myTaskForm.controls['isDueDateTrigger'].setValue(true);
          } else {
            this.myTaskForm.controls['isDueDateTrigger'].setValue(false);
          }

          if (this.taskDetailList.formLink == null) {
            this.disableFormLink = true;
          } else {
            this.disableFormLink = false;
            if (this.taskDetailList.action == 2) {
              this.signNowUrl = this.signNow(this.taskDetailList.formLink, this.taskDetailList);
            }
          }
          this.taskDetailList.action = this.taskDetailList.action.toString();
          this.myTaskForm.controls['selectedTaskActionType'].setValue(this.taskDetailList.action);
          this.myTaskForm.controls['formLink'].setValue(this.taskDetailList.formLink);
          this.setFormURL();
          this.myTaskForm.controls['taskStatus'].setValue(this.taskDetailList.status);
          this.statusID = this.taskDetailList.status;
          this.preorityID = this.taskDetailList.priority.toString();
          this.taskActionType = this.taskDetailList.action;
          //this.getFormLink(this.taskDetailList.action);
          this.getSubTasks(this.responseHolder.data?.subTasks);
          this.selectedFolderID = this.taskDetailList.documentFolderID;
          this.myTaskForm.controls['selectedFolderctrl'].setValue(this.taskDetailList.documentFolderID);
          this.documentFolders = this.taskDetailList.documentFolderModels == null ? [] : this.taskDetailList.documentFolderModels;
          this.selectedColor = this.taskDetailList.colourCode;
          // this.isAttachEntity = this.taskDetailList.attachedEntityID>0?true:false;
          this.entityTypeAssignee = this.taskDetailList.entityTypeAssignee;

          this.entityTypeAttached = this.taskDetailList.entityTypeAttached;

          // for Attach 3c toggle //
          const isAttached = this.taskDetailList.entityTypeAttached;
          this.isAttachEntity = isAttached > 0 ? true : false;
          this.isAssignedEntity = this.entityTypeAssignee > 0 ? true : false;

          // for Attach 3c toggle //

          // Check for Assigned To
          this.getTaskAssignedEntityInDetails = this.taskDetailList.taskAssignedEntity;
          this.getTaskAttachedEntityInDetails = this.taskDetailList.taskAttachedEntity;

          if (this.taskDetailList.taskAttachedEntityMapping != null && this.taskDetailList.taskAttachedEntityMapping != undefined) {
            this.allUploadedDocuments = this.taskDetailList.taskAttachedEntityMapping
          }

          this.selectedAssignedTo = [];

          if (this.getTaskAssignedEntityInDetails.length > 0) {

            // Contact-1,Role-2,Email-3,User-4,RelationShip-5

            for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
              var shortName = "";
              var email = "";
              var imageUrl = "";

              if (this.getTaskAssignedEntityInDetails[i].assigneeName != null) {
                shortName = this.getTaskAssignedEntityInDetails[i].assigneeName.match(/\b(\w)/g).join('');
              }
              if (this.getTaskAssignedEntityInDetails[i].imageUrl != null) {
                imageUrl = this.getTaskAssignedEntityInDetails[i].imageUrl;
              }
              if (this.getTaskAssignedEntityInDetails[i].email != null &&
                (this.getTaskAssignedEntityInDetails[i].entityTypeAssignee == 3 ||
                  this.getTaskAssignedEntityInDetails[i].entityTypeAssignee == 0)) {
                email = this.getTaskAssignedEntityInDetails[i].email;
              }
              if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != null) {
                email = this.getTaskAssignedEntityInDetails[i].assigneeEmail;
              }
              var ReqModelContact = {
                email: email,
                taskAssignedEntityID: this.getTaskAssignedEntityInDetails[i].taskAssignedEntityID,
                taskID: this.taskId,
                contactID: this.getTaskAssignedEntityInDetails[i].contactID,
                roleID: this.getTaskAssignedEntityInDetails[i].roleID,
                userID: this.getTaskAssignedEntityInDetails[i].userID,
                name: this.getTaskAssignedEntityInDetails[i].assigneeName,
                entityTypeAssignee: this.getTaskAssignedEntityInDetails[i].entityTypeAssignee,
                img: imageUrl,
                shortName: shortName,
              }
              if ((ReqModelContact.email != "" && ReqModelContact.email != undefined && ReqModelContact.email != null)
                || this.getTaskAssignedEntityInDetails[i].entityTypeAssignee == 2) {
                this.selectedAssignedTo.push(ReqModelContact);
              }
              if (this.getTaskAssignedEntityInDetails[i].assigneeEmail == null) {
                this.getTaskAssignedEntityInDetails[i].assigneeEmail = "";
              }
              if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
              }
            }

            this.checkedContact = false;
            this.checkedRole = true;
            this.checkedEmail = false;
            this.checkedUser = false;

            this.ShowContactBox = false;
            this.ShowRoleBox = true;
            this.ShowEmailBox = false;
            this.ShowUserBox = false;
          }
          else {
            // Contact-1,Role-2,Email-3,User-4,RelationShip-5

            this.checkedContact = false;
            this.checkedRole = true;
            this.checkedEmail = false;
            this.checkedUser = false;

            this.ShowContactBox = false;
            this.ShowRoleBox = true;
            this.ShowEmailBox = false;
            this.ShowUserBox = false;
          }


          this.attachedToSelectedCore = [];
          this.attachedToSelectedContact = [];
          this.attachedToSelectedCompany = [];

          if (this.getTaskAttachedEntityInDetails.length > 0) {

            // Core-1,Contact-2,Company-3

            // Added For Core
            if (this.entityTypeAttached == 1) {

              this.ShowAttchedToCore = true;
              this.ShowAttchedToContact = false;
              this.ShowAttchedToCompany = false;

              this.checkedAttachCore = true;
              this.checkedAttachContact = false;
              this.checkedAttachCompany = false;
              this.getNormalAndSharedContacts(this.getTaskAttachedEntityInDetails[0].attachedEntityID);
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                var shortName = "";
                shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');
                if (this.getTaskAttachedEntityInDetails[i].imageUrl == null) {
                  this.getTaskAttachedEntityInDetails[i].imageUrl = "";
                }
                var ReqModelAttachCore = {
                  taskAttachedEntityID: this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                  coreID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                  email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                  name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                  title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                  //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                  img: this.getTaskAttachedEntityInDetails[i].imageUrl,
                  typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                  isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                  shortName: shortName
                }
                this.attachedToSelectedCore.push(ReqModelAttachCore);
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Contact
            if (this.entityTypeAttached == 2) {

              this.ShowAttchedToCore = false;
              this.ShowAttchedToContact = true;
              this.ShowAttchedToCompany = false;

              this.checkedAttachCore = false;
              this.checkedAttachContact = true;
              this.checkedAttachCompany = false;
              this.GetContactSelectedContact(this.getTaskAttachedEntityInDetails[0].attachedEntityID);
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                var shortName = "";
                shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');
                if (this.getTaskAttachedEntityInDetails[i].imageUrl == null) {
                  this.getTaskAttachedEntityInDetails[i].imageUrl = "";
                }
                var ReqModelAttachContact = {
                  taskAttachedEntityID: this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                  contactID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                  email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                  name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                  title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                  //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                  img: this.getTaskAttachedEntityInDetails[i].imageUrl,
                  typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                  isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                  shortName: shortName
                }
                this.attachedToSelectedContact.push(ReqModelAttachContact);
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Company
            if (this.entityTypeAttached == 3) {

              this.ShowAttchedToCore = false;
              this.ShowAttchedToContact = false;
              this.ShowAttchedToCompany = true;

              this.checkedAttachCore = false;
              this.checkedAttachContact = false;
              this.checkedAttachCompany = true;
              this.GetCompanySelectedContact(this.getTaskAttachedEntityInDetails[0].attachedEntityID);
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                var shortName = "";
                shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');
                if (this.getTaskAttachedEntityInDetails[i].imageUrl == null) {
                  this.getTaskAttachedEntityInDetails[i].imageUrl = "";
                }
                var ReqModelAttachCompany = {
                  taskAttachedEntityID: this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                  companyID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                  email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                  name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                  title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                  //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                  img: this.getTaskAttachedEntityInDetails[i].imageUrl,
                  typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                  isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                  shortName: shortName
                }
                this.attachedToSelectedCompany.push(ReqModelAttachCompany);
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }
          }
          else {
            // Core-1,Contact-2,Company-3

            // Added For Core
            if (this.entityTypeAttached == 1) {

              this.ShowAttchedToCore = true;
              this.ShowAttchedToContact = false;
              this.ShowAttchedToCompany = false;

              this.checkedAttachCore = true;
              this.checkedAttachContact = false;
              this.checkedAttachCompany = false;

            }
            // Added For Contact
            if (this.entityTypeAttached == 2) {

              this.ShowAttchedToCore = false;
              this.ShowAttchedToContact = true;
              this.ShowAttchedToCompany = false;

              this.checkedAttachCore = false;
              this.checkedAttachContact = true;
              this.checkedAttachCompany = false;
            }
            // Added For Company
            if (this.entityTypeAttached == 3) {

              this.ShowAttchedToCore = false;
              this.ShowAttchedToContact = false;
              this.ShowAttchedToCompany = true;

              this.checkedAttachCore = false;
              this.checkedAttachContact = false;
              this.checkedAttachCompany = true;

            }
          }

          // var obj =JSON.parse(this.taskDetailList.notifyData);

          //  var de = obj?.NotifyEmails ?? "";

          this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);

          this.loaderService.hide();

          if (this.IsCustomFieldExist == true) {
            this.getCoreUserDetails();
          } else {
            this.getAllFolderFields();
          }

          var schl;

          schl = response.data.scheduletask;
          if (this.showAddGroupButton == true) {
            if (schl != null) {
              if (schl.scheduleData != null) {
                if (schl.scheduleType == 6) {
                  this.dependentTaskID = schl.dependentTaskID;
                  if (this.dependentTaskID > 0) {
                    var checks = [];
                    checks = this.SelectDependantTaskList.filter((x: any) => x.taskId == this.dependentTaskID);
                    if (checks.length > 0) {
                      this.depandantTaskDueDate = checks[0].dueDate;
                    }
                  }

                  var scheduleData = JSON.parse(schl.scheduleData);
                  this.myTaskForm.controls['timeperiod'].setValue(scheduleData.timeperiod);
                  this.myTaskForm.controls['timenumber'].setValue(scheduleData.timenumber);
                  this.myTaskForm.controls['afterbefore'].setValue(scheduleData.afterbefore);
                  this.myTaskForm.controls['triggertask'].setValue(scheduleData.dateToUpdate);

                  this.afterbefore = scheduleData.afterbefore;

                  if (scheduleData.dateToUpdate == "intasklist") {
                    this.showSchTask = false;
                  } else {
                    this.showSchTask = true;
                  }

                  var check1 = [];
                  check1 = this.SelectDependantTaskList.filter((x: any) => x.taskId == schl.dependentTaskID);
                  if (check1.length > 0) {
                    this.taskListName = check1[0].taskListName;
                  } else {
                    this.taskListName = "";
                  }

                  var check = [];
                  check = this.taskStatusListForSchedule.filter((x: any) => x.taskStatusConstantName == scheduleData.trigger);
                  if (check.length > 0) {
                    this.myTaskForm.controls['triggerstatus'].setValue(check[0].taskStatusID);
                    this.trigger = check[0].taskStatusConstantName;
                  }

                }
              }
            }
          }


          if (this.showAddGroupButton == false) {
            if (schl != null) {
              if (schl.scheduleData != null) {
                if (schl.scheduleType == 5 || schl.scheduleType == 7) {

                  var scheduleData = JSON.parse(schl.scheduleData);

                  this.myTaskForm.controls['repeatEvery'].setValue(scheduleData.repeatEvery);
                  this.myTaskForm.controls['repeatType'].setValue(scheduleData.repeatType);
                  if (scheduleData.repeatType == 'week') {
                    this.ShowWeeks = true;
                    this.ShowMonths = false;
                    this.ShowYears = false;
                    var data = scheduleData.weeklyRepeat.weekDay;
                    for (var i = 0; i < data.length; i++) {

                      if (data[i] == "Sunday") {
                        this.Sundaychecked = true;
                        this.Sunday = "Sunday";
                      }
                      if (data[i] == "Monday") {
                        this.Mondaychecked = true;
                        this.Monday = "Monday";
                      }
                      if (data[i] == "Tuesday") {
                        this.Tuesdaychecked = true;
                        this.Tuesday = "Tuesday";
                      }
                      if (data[i] == "Wednesday") {
                        this.Wednesdaychecked = true;
                        this.Wednesday = "Wednesday";
                      }
                      if (data[i] == "Thursday") {
                        this.Thursdaychecked = true;
                        this.Thursday = "Thursday";
                      }
                      if (data[i] == "Friday") {
                        this.Fridaychecked = true;
                        this.Friday = "Friday";
                      }
                      if (data[i] == "Saturday") {
                        this.Saturdaychecked = true;
                        this.Saturday = "Saturday";
                      }
                    }
                  }
                  if (scheduleData.repeatType == 'month') {
                    this.ShowWeeks = false;
                    this.ShowMonths = true;
                    this.ShowYears = false;
                    this.myTaskForm.controls['monthDay'].setValue((scheduleData.monthlyRepeat.MonthDay).toString());
                  }
                  if (scheduleData.repeatType == 'year') {
                    this.ShowWeeks = false;
                    this.ShowMonths = false;
                    this.ShowYears = true;
                    this.myTaskForm.controls['yearDay'].setValue((scheduleData.yearlyRepeat.yearDay).toString());
                    this.myTaskForm.controls['yearMonth'].setValue((scheduleData.yearlyRepeat.yearMonth).toString());
                  }

                  if (scheduleData.end.type == "never") {
                    this.neverChecked = true;
                    this.onChecked = false;
                    this.afterChecked = false;
                  }
                  if (scheduleData.end.type == "on") {
                    this.EndOnDate = false;
                    this.Occurence = true;

                    this.neverChecked = false;
                    this.onChecked = true;
                    this.afterChecked = false;

                    this.myTaskForm.controls['EndsOnDate'].setValue(scheduleData.end.on);
                  }

                  if (scheduleData.end.type == "after") {
                    this.EndOnDate = true;
                    this.Occurence = false;

                    this.neverChecked = false;
                    this.onChecked = false;
                    this.afterChecked = true;

                    this.myTaskForm.controls['occurances'].setValue(scheduleData.end.occurances);
                  }
                }
               if (schl.scheduleType == 2) {
                  const scheduleData = schl.scheduleData ? JSON.parse(schl.scheduleData) : null;
                  this.specificDays = scheduleData?.RepeatDays?.map((item: any) => item.RepeatDay) || [];
                }
              }
            }
          }

          this.FieldID = this.taskDetailList.fieldID;

          if (this.taskDetailList.fieldID > 0) {
            this.myTaskForm.controls['isDueOnFieldBased'].setValue(true);
            if (this.isAttachEntity == true) {
              this.showFieldBasedDropdonw = true;
            } else {
              this.showFieldBasedDropdonw = false;
            }
            this.myTaskForm.controls['repeatTaskFieldId'].setValue(Number(this.taskDetailList.fieldID));
          } else {
            this.myTaskForm.controls['isDueOnFieldBased'].setValue(false);
            this.showFieldBasedDropdonw = false;
          }
          if (this.isAttachEntity == true) {
            this.getSynonyms();
            this.showFieldBased = true;
          } else {
            this.getSynonyms();
          }

          this.getRepeatNotification(JSON.parse(this.taskDetailList.notifyData));
          this.getEmailNotification(JSON.parse(this.taskDetailList.actionNotifyData));
          if (this.taskDetailList.actionNotifyData != null) {
            if (this.taskDetailList.actionNotifyData != "null") {
              var dataEmail: any;
              dataEmail = JSON.parse(this.taskDetailList.actionNotifyData);
              dataEmail = dataEmail.emails[0];
              this.EmailTemplate = dataEmail;
              this.myTaskForm.controls['emailTemplate'].setValue(this.EmailTemplate);
            }
          }
        } else {
          this.taskDetailList = [];
          this.loaderService.hide();
        }
      } else {
        this.taskDetailList = [];
        this.loaderService.hide();
      }
    });
  }


  getSubTasks(subTaskList: any) {
    this.allSubTask = subTaskList;
    if (this.allSubTask.length > 0) {
      this.filtersFormArray.controls = [];
      this.allSubTask.forEach(seedDatum => {
        const formGroup = this.createFilterGroup();
        if (seedDatum) {
          formGroup.addControl('taskId', this.getFormControl());
          formGroup.addControl('taskTitle', this.getFormControl());
          formGroup.addControl('status', this.getFormControl());
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormArray.push(formGroup);

        this.showRepeatTaskEmail = true;

      });
    }
  }

  getRepeatNotification(list: any) {
    if (list != null) {
      if (list.NotifyTimes.length > 0) {
        this.filtersFormArrayNotification.controls = [];
        list.NotifyTimes.forEach(seedDatum => {
          const formGroup = this.createFilterGroup();

          // Only add controls if seedDatum exists
          if (seedDatum) {
            formGroup.addControl('timePeriodName', this.getFormControl());
            formGroup.addControl('timePeriodNumber', this.getFormControl());

            formGroup.patchValue(seedDatum);

            // Check if both timePeriodName and timePeriodNumber are not null or empty
            const name = seedDatum.timePeriodName;
            const number = seedDatum.timePeriodNumber;
            if (name !== null && name !== '' && number !== null && number !== '') {
              this.filtersFormArrayNotification.push(formGroup);
              this.showRepeatTaskEmail = true;
            }
          }
        });
      }
    }
  }

  getEmailNotification(list: any) {
    if (list != null) {
      if (list.emailSchedules.length > 0) {
        this.filtersFormArrayNotificationEmail.controls = [];
        list.emailSchedules.forEach(seedDatum => {
          const formGroup = this.createFilterGroupNotificationEmail();
          if (seedDatum) {
            formGroup.addControl('templateID', this.getFormControl());
            formGroup.addControl('number', this.getFormControl());
            formGroup.addControl('period', this.getFormControl());
          }
          formGroup.patchValue(seedDatum);
          this.filtersFormArrayNotificationEmail.push(formGroup);
          this.showRepeatTaskEmail = true;
        });
      }
    }

  }

  deleteTask() {
    const message = `Are you sure you want to delete this task?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskIds: [this.taskId],
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: this.databaseId
          }
          this.loaderService.show();
          this.coreService.removeTasks(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.loaderService.hide();
                this.closeSaveTaskDetail.emit(false);
                this.toastr.success('Task deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  deleteDocument(event: any) {
    this.showTaskUpdateButton = true;
    const message = `Are you sure you want to delete this document?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskAttachedEntityMappingID: event,
          }
          this.loaderService.show();
          this.coreService.DeleteUploadedDocuments(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.loaderService.hide();
                this.getTaskDetailByID();
                this.toastr.success('Document deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Document deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  //==============Update Task Details ===================//

  entityTypeAttached: number = 1;
  entityTypeAssignee: number = 2;
  taskAssignedEntity: any = [] = [];
  taskAttachedEntity: any = [] = [];

  getStatusVal(e: any) {
    this.statusID = e.value;
  }

  getPreorityVal(e: any) {
    this.preorityID = e.value;
  }

  getSubtaskStaus(e: any, index: any) {
    this.filtersFormArray.controls[index].value.status = e.value;
    if (this.allSubTask.find(n => n.taskId == this.filtersFormArray.controls[index].value.taskId) !== undefined)
      this.allSubTask.find(n => n.taskId == this.filtersFormArray.controls[index].value.taskId).status = e.value;
    this.showTaskUpdateButton = true;
  }


  getSubtaskTitle(e: any, index: any) {
    this.filtersFormArray.controls[index].value.taskTitle = e.target.value;
    if (this.allSubTask.find((n: any) => n.taskId == this.filtersFormArray.controls[index].value.taskId) !== undefined)
      this.allSubTask.find((n: any) => n.taskId == this.filtersFormArray.controls[index].value.taskId).taskTitle = e.target.value;
    this.showTaskUpdateButton = true;
  }


  async updateTaskDetail(data: any) {

    if (this.showFieldBased == true) {
      if (this.showFieldBasedDropdonw == true && this.FieldID == 0) {
        this.toastr.warning("Please Select Field.", '', {
          timeOut: 3000,
        });
        return;
      }
    }

    let localDate: any = null;
    if (data.dueDate != null && data.dueDate != "" && data.dueDate != undefined) {
      localDate = moment(data.dueDate).local().format('YYYY-MM-DD');
    }
    let startDate: any = null;
    if (data.startDate != null && data.startDate != "" && data.startDate != undefined) {
      startDate = moment(data.startDate).local().format('YYYY-MM-DD');
    }
    var scheduleTask;
    var ScheduleType: number = 0;
    var Scheduledata;
    // var repeatTask;
    //==== Schedule ====///
    // 0-None,1-SpecificDate,2-Recurring-Hourly,3-Recurring-Daily,
    // 4-Recurring-Weekly,5-Recurring-Monthly,6-ByAnotherTask
    if (this.showAddGroupButton == true) {
      if (this.clearTaskSch == false) {
        if (this.dependentTaskID > 0) {

          if (this.trigger == "") {
            this.toastr.warning("Please select Trigger Status/Due.", '', {
              timeOut: 3000,
            });
            return;
          }

          if (data.triggertask == "" || data.triggertask == null) {
            this.toastr.warning("Please select Trigger this task.", '', {
              timeOut: 3000,
            });
            return;
          }

          if (data.triggertask == "duedate") {

            if (data.timeperiod == "" || data.timeperiod == null) {
              this.toastr.warning("Please select time period.", '', {
                timeOut: 3000,
              });
              return;
            }

            if (data.afterbefore == "" || data.afterbefore == null) {
              this.toastr.warning("Please select after before.", '', {
                timeOut: 3000,
              });
              return;
            }

            if (Number(data.timenumber) >= 0 && (data.timeperiod == "days" || data.timeperiod == "weeks")) {
              if (data.afterbefore == 'none') {
                this.toastr.warning("Please select after or before.", '', {
                  timeOut: 3000,
                });
                return;
              }
            }

          }


          var check = [];
          check = this.taskStatusListForSchedule.filter((x: any) => x.taskStatusID == Number(data.triggerstatus));
          if (check.length > 0) {
            this.trigger = check[0].taskStatusConstantName;
          }

          var schData = {
            trigger: this.trigger,
            statusId: Number(data.triggerstatus),
            timenumber: Number(data.timenumber),
            timeperiod: data.timeperiod,
            afterbefore: data.afterbefore,
            dateToUpdate: data.triggertask
          }
          scheduleTask = {
            scheduleType: 6,
            dependentTaskID: this.dependentTaskID,
            scheduleData: JSON.stringify(schData)
          }
        } else {
          scheduleTask = null;
        }
      } else {
        scheduleTask = null;
      }
    } else {
      scheduleTask = null;
    }


    if (this.showAddGroupButton == false) {
      var weeklyRepeat;
      var monthlyRepeat;
      var yearlyRepeat;
      var end;
      if (this.ShowWeeks == true || this.ShowMonths || this.ShowYears == true) {
        if (data.repeatEvery == "" || data.repeatEvery == null) {
          this.toastr.warning("Please enter repeat every.", '', {
            timeOut: 3000,
          });
          return;
        }
        if (this.ShowWeeks == true) {
          if (this.Sunday == "" && this.Monday == "" && this.Tuesday == ""
            && this.Wednesday == "" && this.Thursday == "" && this.Friday == "" && this.Saturday == "") {
            this.toastr.warning("Please select repeat on.", '', {
              timeOut: 3000,
            });
            return;
          }
          var filterWeek = [this.Sunday, this.Monday, this.Tuesday, this.Wednesday, this.Thursday, this.Friday, this.Saturday]
          var filtered = filterWeek.filter(elm => elm);
          weeklyRepeat = {
            "weekDay": filtered
          }
        } else {
          weeklyRepeat = null;
        }

        if (this.ShowMonths == true) {
          if (data.monthDay == "" || data.monthDay == null) {
            this.toastr.warning("Please select day.", '', {
              timeOut: 3000,
            });
            return;
          }
          monthlyRepeat = {
            "MonthDay": Number(data.monthDay)
          }
        } else {
          monthlyRepeat = null;
        }

        if (this.ShowYears == true) {
          if (data.yearMonth == "" || data.yearMonth == null) {
            this.toastr.warning("Please select month.", '', {
              timeOut: 3000,
            });
            return;
          }
          if (data.yearDay == "" || data.yearDay == null) {
            this.toastr.warning("Please select day.", '', {
              timeOut: 3000,
            });
            return;
          }
          yearlyRepeat = {
            "yearDay": Number(data.yearDay),
            "yearMonth": Number(data.yearMonth),
          }
        } else {
          yearlyRepeat = null;
        }

        var type;
        var on;
        var occurances;
        var ends;
        // var notifyTimes=[];

        if (this.neverChecked == true) {
          type = "never";
          ends = {
            "type": type,
            //"on":on,
            //"occurances":occurances
          }
          // on="";
          // occurances="";
        }
        if (this.onChecked == true) {
          if (data.EndsOnDate == "" || data.EndsOnDate == null) {
            this.toastr.warning("Please select end on.", '', {
              timeOut: 3000,
            });
            return;
          }
          type = "on";
          on = data.EndsOnDate;
          //occurances="";
          ends = {
            "type": type,
            "on": on,
            //"occurances":occurances
          }
        }
        if (this.afterChecked == true) {
          if (data.occurances == "" || data.occurances == null) {
            this.toastr.warning("Please enter occurance.", '', {
              timeOut: 3000,
            });
            return;
          }
          type = "after";
          occurances = Number(data.occurances);
          ends = {
            "type": type,
            "occurances": occurances
          }
        }

        var repeatData = {
          repeatType: data.repeatType,
          repeatEvery: data.repeatEvery,
          weeklyRepeat: weeklyRepeat,
          monthlyRepeat: monthlyRepeat,
          yearlyRepeat: yearlyRepeat,
          end: ends,
        }

        var scheduleType = 0;
        if (this.showFieldBasedDropdonw == true) {
          if (this.FieldID == 0) {
            this.toastr.warning("Please select field.", '', {
              timeOut: 3000,
            });
            return;
          }
          scheduleType = 7;
        } else {
          scheduleType = 5;
        }
        scheduleTask = {
          scheduleType: scheduleType,
          scheduleData: JSON.stringify(repeatData)
        }
      } else {
        scheduleTask = null;
      }

      if (this.specificDays?.length > 0) {

        const RepeatDays = this.specificDays.map((day: number) => ({
          RepeatDay: day,
          Status: 0,
          RepeatedDate: null
        }));

        const scheduleData = {
          BaseDateType: "Date",
          BaseDateFieldId: 0,
          BaseDate: localDate ?? null,
          RepeatDays: RepeatDays
        };


        scheduleTask = {
          scheduleType: 2,
          dependentTaskID:0,
          scheduleData: JSON.stringify(scheduleData)
        }

        // Scheduledata = {
        //   BaseDateType: "Date",
        //   BaseDateFieldId: 0,
        //   BaseDate: null,
        //   RepeatDays: this.specificDays.map((day: number) => ({
        //     RepeatDay: day,
        //     Status: 0,
        //     RepeatedDate: null
        //   }))
        // };

        // ScheduleType = 2;
      }
    } else {
      if (this.dependentTaskID = 0) {
        scheduleTask = null;
      }
    }

    // return;

    //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity = [];
    this.taskAttachedEntity = [];

    if (this.selectedAssignedTo == 0) {
      this.entityTypeAssignee = 0;
    }

    if (this.selectedAssignedTo.length > 0) {
      for (var i = 0, len = this.selectedAssignedTo.length; i < len; ++i) {
        var objj = {
          email: this.selectedAssignedTo[i].email,
          taskAssignedEntityID: this.selectedAssignedTo[i].taskAssignedEntityID,
          taskID: this.taskId,
          contactID: this.selectedAssignedTo[i].contactID,
          roleID: this.selectedAssignedTo[i].roleID,
          userID: this.selectedAssignedTo[i].userID,
          entityTypeAssignee: this.selectedAssignedTo[i].entityTypeAssignee,
          assigneeName: this.selectedAssignedTo[i].name,
        }
        this.taskAssignedEntity.push(objj);
      }
    }

    // For Core 
    if (this.entityTypeAttached == 1) {
      if (this.attachedToSelectedCore.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCore[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCore[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var coreAttached = {
              taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCore[i].coreID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCore[i].title,
              attachedEntityName: this.attachedToSelectedCore[i].name,
              attachedEntityEmail: this.attachedToSelectedCore[i].email,
              attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
              isDeleted: this.attachedToSelectedCore[i].isDeleted,
            }
            this.taskAttachedEntity.push(coreAttached);
          }
        }
      }
    }

    // For Contact 
    if (this.entityTypeAttached == 2) {
      if (this.attachedToSelectedContact.length > 0) {
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedContact[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var contactAttached = {
              taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedContact[i].contactID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedContact[i].title,
              attachedEntityName: this.attachedToSelectedContact[i].name,
              attachedEntityEmail: this.attachedToSelectedContact[i].email,
              attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
              isDeleted: this.attachedToSelectedContact[i].isDeleted,
            }
            this.taskAttachedEntity.push(contactAttached);
          }
        }
      }
    }

    // For Company 
    if (this.entityTypeAttached == 3) {
      if (this.attachedToSelectedCompany.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCompany[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var companyAttached = {
              taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCompany[i].companyID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCompany[i].title,
              attachedEntityName: this.attachedToSelectedCompany[i].name,
              attachedEntityEmail: this.attachedToSelectedCompany[i].email,
              attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
              isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            }
            this.taskAttachedEntity.push(companyAttached);
          }
        }
      }
    }

    let finalSubTaskList: any = [];
    this.filtersFormArray.controls.forEach(ee => {
      finalSubTaskList.push({
        "taskId": ee.value.taskId,
        "taskTitle": ee.value.taskTitle,
        "parentID": this.taskId,
        "status": ee.value.status
      });
    });
    if (data.isInternal == false) {
      data.isInternal = true;
    } else {
      data.isInternal = false;
    }

    if (data.dueDate != null) {
      if (data.dueDate != '') {
        data.dueDate = new Date(data.dueDate);
        data.dueDate = new Date(data.dueDate.getFullYear(), data.dueDate.getMonth(), data.dueDate.getDate(), data.dueDate.getHours(), data.dueDate.getMinutes() - data.dueDate.getTimezoneOffset()).toISOString();

        // new Date(data.dueDate);
        // var dueDateNew= new Date(data.dueDate.getFullYear(), data.dueDate.getMonth(), data.dueDate.getDate(), data.dueDate.getHours(), data.dueDate.getMinutes() - data.dueDate.getTimezoneOffset()).toISOString();
        // //  this.myTaskForm.controls['dueDate'].setValue(dueDateNew);
        // const d = new Date(dueDateNew);
        // d.setDate(d.getDate() + 1);
        // data.dueDate=d;      
      }
    }

    if (data.startDate != null) {
      if (data.startDate != '') {
        data.startDate = new Date(data.startDate);
        data.startDate = new Date(data.startDate.getFullYear(), data.startDate.getMonth(), data.startDate.getDate(), data.startDate.getHours(), data.startDate.getMinutes() - data.startDate.getTimezoneOffset()).toISOString();
      }
    }

    var notifyData;
    var notifyTimes: any = [];
    var notifyDataEmail;
    var notifyTimesEmail: any = [];

    if (this.filtersFormArrayNotification.value.length > 0) {

      if (this.showRepeatTaskEmail == true) {
        if (data.repeatTaskEmail == "" || data.repeatTaskEmail == null) {
          this.toastr.warning("Please add email in Setup Email Notification.", '', {
            timeOut: 3000,
          });
          return;
        }
      }

      data.repeatTaskEmail = data.repeatTaskEmail.replace(/,*$/, '');
      for (var i4 = 0, len4 = this.filtersFormArrayNotification.value.length; i4 < len4; ++i4) {
        if (this.filtersFormArrayNotification.value[i4].timePeriodNumber == "") {
          this.toastr.warning("Please enter time period number in Setup Email Notification.", '', {
            timeOut: 3000,
          });
          return;
        }
      }
      this.filtersFormArrayNotification.controls.forEach(ee1 => {
        notifyTimes.push({
          "timePeriodNumber": ee1.value.timePeriodNumber,
          "timePeriodName": "days",
        });
      });
      notifyData = {
        FirstNotifyDay: 0,
        NotifyEmails: data.repeatTaskEmail,
        NotifyTimes: notifyTimes
      }
    } else {
      notifyData = null;
    }
    if (!this.hasAttachedEntity()) {
      if (this.taskAttachedEntity.length > 0) {
        this.taskAttachedEntity.forEach(e => {
          e.isDeleted = true;
        });
      }
    }

    if (this.filtersFormArrayNotificationEmail.value.length > 0) {

      if (this.showRepeatTaskEmail == true) {
        if (data.emailTemplate == "" || data.emailTemplate == null) {
          this.toastr.warning("Please add email for Setup Email Actions.", '', {
            timeOut: 3000,
          });
          return;
        }
      }

      data.emailTemplate = data.emailTemplate.replace(/,*$/, '');

      for (var i5 = 0, len5 = this.filtersFormArrayNotificationEmail.value.length; i5 < len5; ++i5) {
        if (this.filtersFormArrayNotificationEmail.value[i5].templateID == 0) {
          this.toastr.warning("Please select email template for Setup Email Actions.", '', {
            timeOut: 3000,
          });
          return;
        }
      }

      for (var i6 = 0, len6 = this.filtersFormArrayNotificationEmail.value.length; i6 < len6; ++i6) {
        if (this.filtersFormArrayNotificationEmail.value[i6].number == "") {
          this.toastr.warning("Please enter time period number for Setup Email Actions.", '', {
            timeOut: 3000,
          });
          return;
        }
      }

      this.filtersFormArrayNotificationEmail.controls.forEach(ee1 => {
        notifyTimesEmail.push({
          "templateID": Number(ee1.value.templateID),
          "number": Number(ee1.value.number),
          "period": "days",
        });
      });
      notifyDataEmail = {
        emails: [data.emailTemplate],
        emailSchedules: notifyTimesEmail
      }
    } else {
      notifyDataEmail = null;
    }

    //  const utcDate = moment(data.dueDate).utc().format();
    //  let asd= moment(data.dueDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSSSZ');
    //  let asd1= moment(data.dueDate).utc();

    var notifyDataNew = JSON.stringify(notifyData);
    notifyDataNew = notifyDataNew === 'null' ? null : notifyDataNew;

    var notifyDataEmailNew = JSON.stringify(notifyDataEmail);
    notifyDataEmailNew = notifyDataEmailNew === 'null' ? null : notifyDataEmailNew;

    var ReqModel = {
      subTasks: finalSubTaskList,
      isAddOnlyAssinee: false,
      isAttacheOnly: false,
      taskID: Number(this.taskId),
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger: data.isDueDateTrigger,
      dueDate: localDate,//data.dueDate,
      startDate: startDate,
      Priority: this.preorityID,
      entityTypeAttached: this.entityTypeAttached,
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,
      taskAttachedEntity: this.taskAttachedEntity,

      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      createdBy: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      documentFolderID: this.selectedFolderID,
      action: data.selectedTaskActionType,
      formLink: data.formLink,
      status: this.statusID,
      fieldID: this.FieldID,
      notifyData: notifyDataNew,//notifyData === "null" ? null : JSON.stringify(notifyData),
      actionnotifydata: notifyDataEmailNew,//notifyDataEmail === "null" ? null : JSON.stringify(notifyDataEmail), 
      //notifyData: JSON.stringify(notifyData),
     // actionnotifydata: JSON.stringify(notifyDataEmail),
      scheduleTask: scheduleTask,
      isClear: this.clearTaskSch,
      isRequired: data.isRequired,
      formType: Number(this.formType),

      // scheduledata: Scheduledata ? JSON.stringify(Scheduledata) : null,
      // scheduleType:ScheduleType
      // repeatTask:repeatTask,//
    }
    ReqModel.action = (ReqModel.action == '' ? 0 : ReqModel.action);
    ReqModel.isDueDateTrigger = (ReqModel.isDueDateTrigger == "" || ReqModel.isDueDateTrigger == undefined || ReqModel.isDueDateTrigger == null) ? false : ReqModel.isDueDateTrigger;
    //return;
    this.loaderService.show();
    this.spinner = true;
    this.showTaskUpdateButton = false;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.updateTaskDetails(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      if (this.OpenFromActionFormType == false) {
        this.closeSaveTaskDetail.emit(false);
      }
      if (this.OpenFromActionFormType == true) {
        this.getTaskDetailByID();
      }
      this.loaderService.hide();
      this.toastr.success("Task detail update successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner = false;
      this.loaderService.hide();
      if (this.OpenFromActionFormType == false) {
        this.closeSaveTaskDetail.emit(false);
      }
    }
  }


  toggleColorSelection() {
    this.showColorPannel = !this.showColorPannel;
  }

  SelectColor(color: any) {
    this.selectedColor = color;
    this.showColorPannel = false;
    this.showTaskUpdateButton = true;
  }

  showIntelligence(message: any) {
    this.showPI.emit(message)
  }

  closedetail(message: boolean) {

    this.addEmailButtonShow = false;
    this.showTaskUpdateButton = false;

    // For Contact
    this.selectedContacts = [];
    this.stateCtrl.reset();
    this.contactsList = [];

    // For Role
    this.selectedRole = [];
    this.RoleList = [];

    //For Email
    this.emailAssigned = "";
    this.selectedEmail = [];

    // For User
    this.selectedUser = [];
    this.userList = [];

    // clear taskAssigned
    this.taskAssignedEntity = [];

    this.closeTaskDetail.emit(message);
  }

  showSubtask() {
    this.showSub = !this.showSub;
  }

  markComplete() {
    this.taskComplete = !this.taskComplete
  }

  addTaskOption(val: string) {
    if (val === 'Assigned') {
      this.showAssignedTask = true;
    }
    if (val === 'Reminder') {
      this.showReminderTask = true;
    }
    if (val === 'Schedule') {
      this.showScheduleTask = true;
    }
    if (val === 'Attach') {
      this.showAttachTask = true;
    }
  }

  closeTask(val: boolean) {
    this.showAssignedTask = val
  }

  closeReminder(val: boolean) {
    this.showReminderTask = val
  }

  closeSchedule(val: boolean) {
    this.showScheduleTask = val
  }

  closeAttach(val: boolean) {
    this.showAttachTask = val
  }


  addFolder(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }


  addtasks(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }





  /// ============================================  Assigned To  ==========================================//



  // ============ For Search/Select Contact ==================//

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state: any) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  selectCRE($event: MatRadioChange) {

    this.addEmailButtonShow = false;
    this.showTaskUpdateButton = true;

    // For Contact

    this.stateCtrl.reset();
    this.contactsList = [];

    // For Role
    this.RoleList = [];

    //For Email
    this.emailAssigned = "";

    // For User
    this.selectedUser = [];

    // clear taskAssigned
    this.taskAssignedEntity = [];

    if ($event.value === 'Contact') {
      this.ShowContactBox = true;
      this.ShowRoleBox = false;
      this.ShowEmailBox = false;
      this.ShowUserBox = false;
      this.ShowRelationshipBox = false;
      this.entityTypeAssignee = 1;
    }
    if ($event.value === 'Role') {
      this.ShowContactBox = false;
      this.ShowRoleBox = true;
      this.ShowEmailBox = false;
      this.ShowUserBox = false;
      this.ShowRelationshipBox = false;
      this.entityTypeAssignee = 2;
    }
    if ($event.value === 'Email') {
      this.ShowContactBox = false;
      this.ShowRoleBox = false;
      this.ShowEmailBox = true;
      this.ShowUserBox = false;
      this.ShowRelationshipBox = false;
      this.entityTypeAssignee = 3;
    }
    if ($event.value === 'User') {
      this.ShowContactBox = false;
      this.ShowRoleBox = false;
      this.ShowEmailBox = false;
      this.ShowUserBox = true;
      this.ShowRelationshipBox = false;
      this.entityTypeAssignee = 4;
    }
    if ($event.value === 'Relationship') {
      this.ShowContactBox = false;
      this.ShowRoleBox = false;
      this.ShowEmailBox = false;
      this.ShowUserBox = false;
      this.ShowRelationshipBox = true;
      this.entityTypeAssignee = 5;
    }
  }

  searchContact(val) {
    if (val.length >= 2) {
      this.contactsList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getContactListCoreImplementation(val)
        }, 500);
      } else {
        this.contactsList = [];
      }
    }
  }

  getContactListCoreImplementation(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
    }
    this.settingsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach((e: any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
        } else {
          this.contactsList = [];
        }
      }
    })
  }


  onEnter(event: any, contact: any) {
    this.stateCtrl.setValue('');
    var findContact = this.selectedContacts.filter((x: any) => x.name === event.target.value);
    if (findContact.length != undefined && findContact.length > 0) {
      let user = this.selectedContacts.find((m: any) => m.contactID == findContact[0].contactID);
      if (user == undefined || user == '' || user == null) {
        var req = {
          contactID: findContact[0].contactID,
          email: findContact[0].email,
          name: findContact[0].name,
          img: findContact[0].imageUrl,
          shortName: findContact[0].shortName
        }
        this.selectedContacts.unshift(req);
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
          this.showTaskUpdateButton = true;
        }
        else {
          this.showTaskUpdateButton = false;
        }
      } else {
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
          this.showTaskUpdateButton = true;
        }
        else {
          this.showTaskUpdateButton = false;
        }
      }
    }
  }

  contactSelected(contactSelected: any) {
    this.stateCtrl.setValue('');
    this.stateCtrl.reset();
    var user = [];
    user = this.selectedAssignedTo.filter((m: any) => m.contactID == contactSelected.contactID && m.entityTypeAssignee == 1);
    if (user.length == 0) {

      var shortName = contactSelected.name.match(/\b(\w)/g).join('');

      var ReqModel = {
        name: contactSelected.name,
        taskAssignedEntityID: 0,
        taskID: this.taskId,
        email: contactSelected.email,
        contactID: contactSelected.contactID,
        role: 0,
        userID: null,
        entityTypeAssignee: 1,
        img: contactSelected.imageUrl,
        shortName: shortName
      }
      this.selectedAssignedTo.push(ReqModel);

      if (contactSelected.email != "") {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        email += contactSelected.email + ',';
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
      }
    } else {
      this.toastr.warning('Contact allready added.', '', {
        timeOut: 3000,
      });
    }
    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length == 0) {
      this.showTaskUpdateButton = false;
    }
  }

  removeContact(item: any) {
    const index = this.selectedContacts.indexOf(item);
    if (index >= 0) {
      this.selectedContacts.splice(index, 1);
      this.showTaskUpdateButton = true;
    }
    if (this.selectedContacts.length == 0) {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = false;
    }
    else {
      this.showTaskUpdateButton = true;
    }

  }



  // =========================== For Role  ===============================//

  RoleList: any = [] = [];
  selectedRole: any = [] = [];

  searchRoles(searchValue: any) {
    var ReqModel = {
      searchKey: "",
      pageIndex: 0,
      pageSize: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      searchValue: searchValue
    }
    this.settingsService.getSharedAccessRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.RoleList = response.data;
        }
        else {
        }
      }
    });
  }

  roleSelected(roleSelected: any) {
    this.stateCtrl.setValue('');
    var newRole = [];
    newRole = this.selectedAssignedTo.filter((m: any) => m.roleID == roleSelected.roleID && m.entityTypeAssignee == 2);
    if (newRole.length == 0) {

      var shortName = roleSelected.roleName.match(/\b(\w)/g).join('');

      this.selectedAssignedTo.push({
        name: roleSelected.roleName,
        taskAssignedEntityID: 0,
        taskID: this.taskId,
        email: "",
        contactID: 0,
        roleID: roleSelected.roleID,
        userID: null,
        entityTypeAssignee: 2,
        img: "",
        shortName: shortName
      });
      if (this.selectedAssignedTo.length > 0) {
        this.showTaskUpdateButton = true;
      }
      if (this.selectedAssignedTo.length == 0) {
        this.showTaskUpdateButton = false;
      }
    } else {
      this.toastr.warning('Role allready added.', '', {
        timeOut: 3000,
      });
    }

    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }

  }

  removeRole(item: any) {
    const index = this.selectedAssignedTo.indexOf(item);
    if (index >= 0) {
      this.selectedAssignedTo.splice(index, 1);
      this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }
  }

  removeAssignedTo(item: any) {
    const index = this.selectedAssignedTo.indexOf(item);
    if (index >= 0) {
      this.selectedAssignedTo.splice(index, 1);
      this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }

    if (item.email) {
      var email = this.myTaskForm.get('repeatTaskEmail').value;
      var array = [];
      array = email.split(',');
      if (array.length > 0) {
        array = array.filter(e => e !== item.email);
        if (array.length > 0) {
          var test = array.join(",")
          this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
        }
      } else {
        this.filtersFormArrayNotification.value.length = 0;
        this.dynamicFormNotification = this.formBuilder.group({
          filtersmNotification: this.formBuilder.array([])
        });
        this.showRepeatTaskEmail = false;
      }
    }
  }


  // ======================= Email ===============================//

  selectedEmail: any = [] = [];
  emailAssigned: string = "";

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

  addEmail() {
    var check = [];
    check = this.selectedAssignedTo.filter((x: any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase()
      && x.entityTypeAssignee == 3)

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        taskAssignedEntityID: 0,
        taskID: this.taskId,
        email: this.emailAssigned,
        contactID: 0,
        role: 0,
        userID: null,
        entityTypeAssignee: 3,
        img: "",
        shortName: shortName
      }
      this.selectedAssignedTo.push(obj);


      if (this.emailAssigned != "") {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        email += this.emailAssigned + ',';
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
      }

      this.emailAssigned = "";
      this.addEmailButtonShow = false;

    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }


    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length == 0) {
      this.showTaskUpdateButton = false;
    }
  }

  removeEmail(item: any) {
    const index = this.selectedEmail.indexOf(item);
    if (index >= 0) {
      this.selectedEmail.splice(index, 1);
    }
    if (this.selectedEmail.length > 0) {
      this.showTaskUpdateButton = true;
    }
  }





  // ======================= User ===============================//

  selectedUser: any = [] = [];
  userList: any = [];

  searchUser(val) {
    if (val.length >= 2) {
      this.userList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.userList = [];
      }
    }
  }

  searchRelationShip(val) {
    if (val.length >= 2) {
      this.resultUIRelationship = [];
      if (val != '') {
        this.relationShips.forEach(rs => {
          if (rs.rloeName.toLowerCase().includes(val)) {
            if (!this.resultUIRelationship.includes(rs))
              this.resultUIRelationship.push(rs);
          }
        });
      } else {
        this.resultUIRelationship = [];
      }
    }
  }


  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.userList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.settingsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.userList = response.data.userModel;
          this.userList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.userList = this.userList;
        }
      }
    });
  }


  relationSelected(rs: any) {
    if (!this.selectedUIRelationship.find(m => m.transctionalRoleID == rs.transctionalRoleID && m.id == rs.id)) {
      this.selectedUIRelationship.push(rs);
    }
    if (this.selectedUIRelationship.length > 0) {
      this.showTaskUpdateButton = true;
    }
    else {
      this.showTaskUpdateButton = false;
    }
    this.stateCtrl.setValue('');
  }


  userSelected(userSelected: any) {
    this.stateCtrl.setValue('');
    var user = [];
    user = this.selectedAssignedTo.filter(m => m.userID == userSelected.uuid && m.entityTypeAssignee == 4);
    if (user.length == 0) {

      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');

      this.selectedAssignedTo.push({
        name: userSelected.firstName + " " + userSelected.lastName,
        taskAssignedEntityID: 0,
        taskID: this.taskId,
        email: userSelected.email,
        contactID: 0,
        role: 0,
        userID: userSelected.uuid,
        entityTypeAssignee: 4,
        img: "",
        shortName: shortName
      });

      if (userSelected.email != "") {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        email += userSelected.email + ',';
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
      }
    } else {
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if (this.selectedAssignedTo.length > 0) {
      this.showTaskUpdateButton = true;
    }
    else {
      this.showTaskUpdateButton = false;
    }
  }

  removeUser(item: any) {
    const index = this.selectedUser.indexOf(item);
    if (index >= 0) {
      this.selectedUser.splice(index, 1);
      this.showTaskUpdateButton = true;
    }
    if (this.selectedUser.length == 0) {
      this.stateCtrl.reset();
    }
  }

  removeRs(item: any) {
    const index = this.selectedUIRelationship.indexOf(item);
    if (index >= 0) {
      this.selectedUIRelationship.splice(index, 1);
      this.showTaskUpdateButton = true;
    }
    if (this.selectedUIRelationship.length == 0) {
      this.stateCtrl.reset();
    }
  }















  // =========================================== Attached to ===========================================//


  ShowAttchedToCore: boolean = false;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;


  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  attachedToCompanyList: any = [] = [];


  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
  attachedToSelectedCompany: any = [] = [];

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;

  roleIdList: any = [];

  checkedAttachCore: boolean = false;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  selectCCC($event: MatRadioChange) {
    this.stateCtrl.reset();
    if ($event.value === 'Core') {
      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;

      this.entityTypeAttached = 1;

      this.showFieldBased = true;
      this.getSynonyms();
    }
    if ($event.value === 'Contact') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;

      this.entityTypeAttached = 2;
      this.showFieldBased = true;
      this.getSynonyms();
    }
    if ($event.value === 'Company') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;

      this.entityTypeAttached = 3;
      this.showFieldBased = true;
      this.getSynonyms();
    }
    this.taskDetailList.documentFolderID = 0;
    this.selectedFolderID = 0;
    this.showTaskUpdateButton = true;
    this.documentFolders = [];
    this.attachedToSelectedCore = [];
    this.attachedToSelectedContact = [];
    this.attachedToSelectedCompany = [];
  }



  //======================Core============================//

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;

        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }


  attchedToCoreSelected(coreSelected: any) {
    var checkCore = [];
    this.stateCtrl.setValue('');
    checkCore = this.attachedToSelectedCore.filter((x: any) => x.isDeleted == false);
    if (checkCore.length == 0) {
      var shortName = "";
      shortName = coreSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        taskAttachedEntityID: 0,
        coreID: coreSelected.coreID,
        email: coreSelected.email,
        name: coreSelected.name,
        title: coreSelected.title,
        transactionID: coreSelected.transactionID,
        img: coreSelected.imageUrl,
        typeID: coreSelected.typeID,
        isDeleted: false,
        shortName: shortName,
      }
      this.attachedToSelectedCore.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCore.length > 0) {
        this.showTaskUpdateButton = true;
      } else {
        this.showTaskUpdateButton = false;
      }

      if (coreSelected.email != "") {

        var email = this.myTaskForm.get('repeatTaskEmail').value;
        //  this.repeatTaskEmail+= contactSelected.email+','; 
        email += coreSelected.email + ',';
        // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        // this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);

        //   this.repeatTaskEmail+= coreSelected.email+','; 
        //  // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //   this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
      }

    }
    //this.getNormalAndSharedCompanys(coreSelected.coreID);
    this.getNormalAndSharedContacts(coreSelected.coreID);
    this.GetAttachedEntityDocumentFolders(coreSelected.coreID, 1);
  }

  attchedToRemoveCore(item: any) {
    if (this.attachedToSelectedCore.length > 0) {
      this.attachedToSelectedCore.map(e => {
        if (e.coreID == item.coreID) {
          e.isDeleted = true
        }
        return e;
      });
      this.showTaskUpdateButton = false;
      //this.entityTypeAttached = 0
      this.documentFolders = [];
      this.selectedFolderID = 0;

      if (item.email) {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        var array = [];
        array = email.split(',');
        if (array.length > 0) {
          array = array.filter(e => e !== item.email);
          if (array.length > 0) {
            var test = array.join(",")
            this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
          }
        } else {
          this.filtersFormArrayNotification.value.length = 0;
          this.dynamicFormNotification = this.formBuilder.group({
            filtersmNotification: this.formBuilder.array([])
          });
          this.showRepeatTaskEmail = false;
        }
      }
    }

    var checkCore = [];
    checkCore = this.attachedToSelectedCore.filter((x: any) => x.isDeleted == false);
    if (checkCore.length == 0) {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = false;
    } else {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = true;
    }
    this.showTaskUpdateButton = true;
    //this.isAttachEntity = false;    
  }




  //======================Contact============================//

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  onfolderSelectionChanged(val) {
    this.selectedFolderID = val.value;
  }

  GetAttachedEntityDocumentFolders(entityID: any, AttachedEntityType: any) {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      TransactionID: entityID,
      AttachedEntityType: AttachedEntityType,
    }
    this.coreService.GetAttachedEntityDocumentFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.documentFolders = response.data;

        } else {
          this.documentFolders = [];
        }
      }
    })
  }


  getsearchContact(searchValue: any) {
    var SelectedCCC = [];

    SelectedCCC = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;

        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }


  attchedToContactSelected(contactSelected: any) {
    var checkContact = [];
    this.stateCtrl.setValue('');
    checkContact = this.attachedToSelectedContact.filter((x: any) => x.isDeleted == false);
    if (checkContact.length == 0) {
      var shortName = "";
      shortName = contactSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        taskAttachedEntityID: 0,
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        title: contactSelected.title,
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,
        typeID: contactSelected.typeID,
        isDeleted: false,
        shortName: shortName,
      }
      this.attachedToSelectedContact.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedContact.length > 0) {
        this.showTaskUpdateButton = true;
      } else {
        this.showTaskUpdateButton = false;
      }

      if (contactSelected.email != "") {

        var email = this.myTaskForm.get('repeatTaskEmail').value;
        //  this.repeatTaskEmail+= contactSelected.email+','; 
        email += contactSelected.email + ',';
        // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        // this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);

        //   this.repeatTaskEmail+= contactSelected.email+','; 
        //  // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //   this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
      }

    }
    this.GetContactSelectedContact(contactSelected.contactID);
    this.GetAttachedEntityDocumentFolders(contactSelected.contactID, 2);
  }


  attchedToRemoveContact(item: any) {
    if (this.attachedToSelectedContact.length > 0) {
      this.attachedToSelectedContact.map(e => {
        if (e.contactID == item.contactID) {
          e.isDeleted = true
        }
        return e;
      });
      this.showTaskUpdateButton = false;
      this.documentFolders = [];
      this.selectedFolderID = 0;

      if (item.email) {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        var array = [];
        array = email.split(',');
        if (array.length > 0) {
          array = array.filter(e => e !== item.email);
          if (array.length > 0) {
            var test = array.join(",")
            this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
          }
        } else {
          this.filtersFormArrayNotification.value.length = 0;
          this.dynamicFormNotification = this.formBuilder.group({
            filtersmNotification: this.formBuilder.array([])
          });
          this.showRepeatTaskEmail = false;
        }
      }
    }

    var checkContact = [];
    checkContact = this.attachedToSelectedContact.filter((x: any) => x.isDeleted == false);
    if (checkContact.length == 0) {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = false;
    } else {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = false;
    }
    this.showTaskUpdateButton = true;
  }





  //======================Company============================//

  searchCompany(val) {
    if (val.length >= 2) {
      this.attachedToCompanyList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCompany(val)
        }, 500);
      } else {
        this.attachedToCompanyList = [];
      }
    }
  }

  getsearchCompany(searchValue: any) {
    var SelectedCCC = [];

    SelectedCCC = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Company');
    if (SelectedCCC.length > 0) {
      this.CompanyfolderID = SelectedCCC[0].folderID;
    }

    this.roleIdList = [];

    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CompanyfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.settingsService.searchCompany(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCompanyList = response.data;

        } else {
          this.attachedToCompanyList = [];
        }
      }
    })
  }



  attchedToCompanySelected(companySelected: any) {
    var checkCompany = [];
    this.stateCtrl.setValue('');
    checkCompany = this.attachedToSelectedCompany.filter((x: any) => x.isDeleted == false);
    if (checkCompany.length == 0) {
      var shortName = "";
      shortName = companySelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {
        taskAttachedEntityID: 0,
        companyID: companySelected.companyID,
        email: companySelected.email,
        name: companySelected.name,
        title: companySelected.title,
        transactionID: companySelected.transactionID,
        img: companySelected.imageUrl,
        typeID: companySelected.typeID,
        isDeleted: false,
        shortName: shortName,
      }
      this.attachedToSelectedCompany.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCompany.length > 0) {
        this.showTaskUpdateButton = true;
      } else {
        this.showTaskUpdateButton = false;
      }

      if (companySelected.email != "") {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        //  this.repeatTaskEmail+= contactSelected.email+','; 
        email += companySelected.email + ',';
        // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        // this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        this.myTaskForm.controls['repeatTaskEmail'].setValue(email);

        //   this.repeatTaskEmail+= companySelected.email+','; 
        //  // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //   this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
      }

    }
    this.GetCompanySelectedContact(companySelected.companyID);
    this.GetAttachedEntityDocumentFolders(companySelected.companyID, 3);
  }

  attchedToRemoveCompany(item: any) {
    if (this.attachedToSelectedCompany.length > 0) {
      this.attachedToSelectedCompany.map((e: any) => {
        if (e.companyID == item.companyID) {
          e.isDeleted = true
        }
        return e;
      });
      this.showTaskUpdateButton = false;
      this.documentFolders = [];
      this.selectedFolderID = 0;

      if (item.email) {
        var email = this.myTaskForm.get('repeatTaskEmail').value;
        var array = [];
        array = email.split(',');
        if (array.length > 0) {
          array = array.filter((e: any) => e !== item.email);
          if (array.length > 0) {
            var test = array.join(",")
            this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
          }
        } else {
          this.filtersFormArrayNotification.value.length = 0;
          this.dynamicFormNotification = this.formBuilder.group({
            filtersmNotification: this.formBuilder.array([])
          });
          this.showRepeatTaskEmail = false;
        }
      }

    }
    var checkCompany = [];
    checkCompany = this.attachedToSelectedCompany.filter((x: any) => x.isDeleted == false);
    if (checkCompany.length == 0) {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = false;
    } else {
      this.stateCtrl.reset();
      this.showTaskUpdateButton = true;
    }
    this.showTaskUpdateButton = true;
  }

  //#region Add Tasks Dynamic fields


  // Add Tasks Dynamic fields

  getShortName(fullName: any) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n: any) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  CheckName(val: any) {
    if (val.trim() == "" || val.trim() == undefined || val.trim() == null || val.trim() == "-") {
      this.myFormGroup.controls['Name'].setErrors({ 'incorrect': true });
      return;
    }
    if (val.toLowerCase() != val.toLowerCase().match('^[a-z0-9_%+-]+@[a-z0-9-]+\\[a-z]{2,4}$') && val.indexOf('@') == -1) {
    } else {
      this.myFormGroup.controls['Name'].setErrors({ 'incorrect': true });
    }
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check = [];
    check = this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if (check.length > 0) {
      this.fruitCtrl.setValue(null);
      return;
    }
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags = this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';
    this.getTagListModel.PageSize = 0;
    this.getTagListModel.officeID = this.myOfficeID;
    this.getTagListModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;
        }
        else {

        }
      }
    });
  }


  searchZip(zip: any) {
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.zipOption = [];
          response.data.forEach((element: any) => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name: any) {
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.cityOption = [];
          response.data.forEach((element: any) => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConst.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x: any) => x.abbreviation != null);
              response.data.forEach((e: any) => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach((e: any) => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addMore(fieldName: any) {
    if (fieldName == 'Email') {
      let length = this.dynamicArray.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl: any) => {
        if (formControl.fieldName == 'Email') {
          this.dynamicArray.push(formControl);
        }
      });
    }
    // Phone
    if (fieldName == 'Phone') {
      let length = this.dynamicArrayPhone.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl: any) => {
        if (formControl.fieldName == 'Phone') {
          this.dynamicArrayPhone.push(formControl);
        }
      });
    }
    //Address
    if (fieldName == 'Address') {
      let length = this.dynamicArrayAddress.length;
      length = length + 1;

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));

      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));
      //

      this.coreFieldSaveCompare.forEach((formControl: any) => {
        if (formControl.fieldName == 'Address') {
          this.dynamicArrayAddress.push(formControl);
        }
      });
    }
    //Website
    if (fieldName == 'WebSite') {
      let length = this.dynamicArrayWebsite.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl: any) => {
        if (formControl.fieldName == 'WebSite') {
          this.dynamicArrayWebsite.push(formControl);
        }
      });
    }
  }
  addressValueField: any = Object;
  cityValueField: any = Object;
  stateValueField: any = Object;
  zipValueField: any = Object;
  addMoreEditField(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl: any) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl: any) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl: any) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl: any) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }


  // get all created Feilds
  getAllFolderFields() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    var reqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      folderID: this.folderID,//17;
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    //this.loaderService.show();
    this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          //this.transactionUserName = this.taskDetailList.title; 
          this.coreFieldSaveCompare = response.data.activeFields.filter((m: any) => m.fieldID > 0);

          this.coreFieldSaveCompareForType = response.data.activeFields.filter((m: any) => m.fieldID > 0);

          this.coreFieldList = response.data.activeFields;
          this.AllTypeList = response.data.types;
          this.AllTypeList.splice(0, 0, { folderName: "Select", isChecked: false, subFolderID: 0 });

          // var NewList;
          // NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          // if(type.length>0){
          //   NewList.splice(1, 0, type[0]);
          // }         
          // this.coreFieldList = NewList;

          this.imagelist = this.coreFieldList.filter((e: any) => e.fieldTypeName == 'Image');
          this.coreFieldList = this.coreFieldList.filter((s: any) => s.fieldTypeName != 'Image');
          this.coreFieldList = this.coreFieldList.filter((s: any) => s.isActive == true);
          this.coreFieldList = this.coreFieldList.filter((s: any) => s.availableOn != 2);
          this.coreFieldList = this.coreFieldList.filter((s: any) => s.rolePermission != 2);

          this.coreFieldListForType = this.coreFieldList;

          const Fields = {};
          this.coreFieldList.forEach((formControl: any) => {
            if (formControl.fieldID == 0 && formControl.data.length > 0) {
              formControl.data.forEach((ctrlgrp: any,) => {
                if (ctrlgrp.fieldID > 0) {
                  this.coreFieldSaveCompare.push(ctrlgrp);
                  if (ctrlgrp.fieldName == 'Phone')
                    Fields[ctrlgrp.fieldName] = new FormControl(
                      '',
                      Validators.pattern(phoneNumberregex)
                    );
                  else {
                    Fields[ctrlgrp.fieldName] = new FormControl('');
                  }
                  if (ctrlgrp.fieldNames.length > 0) {
                    const toSelect = ctrlgrp.fieldNames[0];
                    this.tempValue = toSelect;
                    Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                  }
                }
              });
            }
            else {
              if (formControl.fieldName == 'Phone')
                Fields[formControl.fieldName] = new FormControl(
                  '',
                  Validators.pattern(phoneNumberregex)
                );
              else Fields[formControl.fieldName] = new FormControl('');

              if (formControl.fieldNames.length > 0) {
                const toSelect = formControl.fieldNames[0];
                this.tempValue = toSelect;
                Fields[formControl.fieldName + 'option'] = new FormControl();
              }
            }
          });
          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');
          //
          ///
          this.myFormGroup = new FormGroup(Fields);

          // Check for Without Group //
          this.dropdownlist = this.coreFieldList.filter((s: any) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.coreFieldList.filter((s: any) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.coreFieldList.filter((s: any) => s.fieldTypeName == 'Checkbox');

          var data = [];

          data = this.coreFieldList.filter((s: any) => s.fieldID == 0);

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s: any) => s.fieldTypeName == 'Dropdown');
              if (DrpData.length > 0) {
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }

              var MultiData = [];
              MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
              if (MultiData.length > 0) {
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }

              var CheckboxData = [];
              CheckboxData = data[i].data.filter((s: any) => s.fieldTypeName == 'Checkbox');
              if (CheckboxData.length > 0) {
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }
            }
          }

          if (this.dropdownlist.length > 0) {
            var fieldListdrp = [];
            var value;
            for (let i = 0; i < this.dropdownlist.length; i++) {
              var dropValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
              value = dropValue.split(',');
              var FieldsDrp = {
                FieldValue: this.dropdownlist[i].fieldName,
                value: value,
              };
              fieldListdrp.push(FieldsDrp);
            }
            this.dropdownlist = fieldListdrp;
          }

          if (this.multipleDropdownList.length > 0) {
            var fieldmulListdrp = [];
            var value;
            for (let i = 0; i < this.multipleDropdownList.length; i++) {
              var multidropValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
              value = multidropValue.split(',');

              var FieldsMulDrp = {
                FieldValue: this.multipleDropdownList[i].fieldName,
                value: value,
              };
              fieldmulListdrp.push(FieldsMulDrp);
            }
            this.multipleDropdownList = fieldmulListdrp;
          }

          if (this.checkBoxList.length > 0) {
            var fieldcheckbox = [];
            var value;
            for (let i = 0; i < this.checkBoxList.length; i++) {
              var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
              value = checkboxValue.split(',');
              var FieldsCheckbox = {
                FieldValue: this.checkBoxList[i].fieldName,
                value: value,
              };
              fieldcheckbox.push(FieldsCheckbox);
            }
            this.checkBoxList = fieldcheckbox;
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getSubFolderFields(event: any, fieldName: any) {
    if (event != undefined && fieldName == "Type") {
      var reqModel = {
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        FolderId: this.folderID,//17;
        subFolderID: 0,
        fieldID: 0,
        requestFrom: 0,
        officeID: this.myOfficeID,
        OfficeIDList: this.OfficeIDList
      }
      this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.coreFieldSaveCompareForType = response.data.activeFields.filter((m: any) => m.fieldID > 0);
          }

          this.coreFieldListForType = response.data.activeFields.filter((s: any) => s.fieldTypeName != 'Image');

          // var NewList;
          // NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          // if(type.length>0){
          //   NewList.splice(1, 0, type[0]);
          // }                  
          // this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s: any) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s: any) => s.isActive == true);
        }
        this.getTypeFieldList(event);
      });

    }
  }

  getTypeFieldList(event: any) {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.typeId = event.value;
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      folderID: this.folderID,//17;
      subFolderID: this.typeId,
      fieldID: 0,
      requestFrom: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderFieldsListResponseHolder = response;
        if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
          this.fieldsList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s: any) => s.fieldTypeName != 'Image');

          this.AllTypeList = this.getSubFolderFieldsListResponseHolder.data.types;
          this.AllTypeList.splice(0, 0, { folderName: "Select", isChecked: false, subFolderID: 0 });


          this.coreFieldListForType = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s: any) => s.fieldTypeName != 'Image');

          this.coreFieldListForType = this.fieldsList;
          this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
          // this.coreFieldList = this.coreFieldListForType;

          // var NewList;
          // NewList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          // if(type.length>0){
          //   NewList.splice(1, 0, type[0]);
          // }               
          // this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s: any) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s: any) => s.isActive == true);


          this.selectedTypefieldsList = this.fieldsList.filter(({ fieldID: id1 }) => !this.coreFieldList.some(({ fieldID: id2 }) => id2 === id1));
          this.selectedTypefieldsList = this.selectedTypefieldsList.filter((s: any) => s.fieldID > 0);

          var tempArryacoreFieldList = [];
          tempArryacoreFieldList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((m) => m.fieldID == 0);

          if (tempArryacoreFieldList.length > 0) {
            var check = this.coreFieldList.filter(({ position: id1 }) => !this.fieldsList.some(({ position: id2 }) => id2 === id1));
            if (check.length == 0) {
              tempArryacoreFieldList = [];
            }
          }

          this.dropdownlist = this.fieldsList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.fieldsList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.fieldsList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];
          this.arryaControlNameIdpare = [];
          data = this.fieldsList.filter((s) => s.fieldID == 0);

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s: any) => s.fieldTypeName == 'Dropdown');
              if (DrpData.length > 0) {
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }

              var MultiData = [];
              MultiData = data[i].data.filter((s: any) => s.fieldTypeName == 'MultiSelect');
              if (MultiData.length > 0) {
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }

              var CheckboxData = [];
              CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
              if (CheckboxData.length > 0) {
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }
            }
          }

          if (this.dropdownlist.length > 0) {
            var fieldListdrp = [];
            var value;
            for (let i = 0; i < this.dropdownlist.length; i++) {

              var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
              value = drpValue.split(',');
              var FieldsDrp = {
                FieldValue: this.dropdownlist[i].fieldName,
                value: value,
              };
              fieldListdrp.push(FieldsDrp);
            }
            this.dropdownlist = fieldListdrp;
          }

          if (this.multipleDropdownList.length > 0) {
            var fieldmulListdrp = [];
            var value;
            for (let i = 0; i < this.multipleDropdownList.length; i++) {
              var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
              value = muldrpValue.split(',');
              var FieldsMulDrp = {
                FieldValue: this.multipleDropdownList[i].fieldName,
                value: value,
              };
              fieldmulListdrp.push(FieldsMulDrp);
            }
            this.multipleDropdownList = fieldmulListdrp;
          }

          if (this.checkBoxList.length > 0) {
            var fieldcheckbox = [];
            var value;
            for (let i = 0; i < this.checkBoxList.length; i++) {
              var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
              value = checkboxValue.split(',');
              var FieldsCheckbox = {
                FieldValue: this.checkBoxList[i].fieldName,
                value: value,
              };
              fieldcheckbox.push(FieldsCheckbox);
            }
            this.checkBoxList = fieldcheckbox;
          }



          // Modified array containing group starts
          tempArryacoreFieldList.forEach((element: any) => {
            if (element.data.length > 1) {
              var indexArray = [];
              element.data.forEach((elementin: any) => {
                if (elementin.fieldID > 0) {
                  let grpele = this.coreFieldList.find((x: any) => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                  elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                  elementin.id = grpele != undefined ? grpele.id : 0;
                  elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                  if (elementin.fieldNames.length > 0) {
                    if (grpele != undefined) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                  }
                  this.coreFieldList.push(elementin);
                  if (!this.myFormGroup.contains(elementin.fieldName)) {
                    this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                  }
                  var index = this.coreFieldList.findIndex((x: any) => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                  indexArray.push(index);
                }
              });

              this.coreFieldList = this.coreFieldList.filter(function (value, index) {
                return indexArray.indexOf(index) == -1;
              });
              this.coreFieldList.splice(indexArray[0], 0, element);
            }
          });


          if (this.selectedTypefieldsList.length == 0) {
            this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
            this.coreFieldList = this.coreFieldListForType;

            this.coreFieldList = this.coreFieldList.filter((s: any) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s: any) => s.rolePermission != 2);

            const Fields = {};
            this.coreFieldList.forEach((formControl: any) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {

                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl(
                        '',
                        Validators.pattern(phoneNumberregex)
                      );
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl(
                    '',
                    Validators.pattern(phoneNumberregex)
                  );
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            });

          }

          this.arryaControlNameIdpare = [];

          if (this.selectedTypefieldsList.length > 0) {
            for (let i = 0; i < this.selectedTypefieldsList.length; i++) {
              this.coreFieldSaveCompare.push(this.selectedTypefieldsList[i]);
              this.arryaControlNameIdpare.push({
                name: this.selectedTypefieldsList[i].fieldName,
                id: this.selectedTypefieldsList[i].id,
                subfolderID: this.selectedTypefieldsList[i].subfolderID
              });
              var index = this.fieldsList.findIndex(x => x.fieldName == this.selectedTypefieldsList[i].fieldName && x.fieldID == this.selectedTypefieldsList[i].fieldID);
              this.coreFieldList.splice(index, 0, this.selectedTypefieldsList[i]);
            }

            this.selectedTypefieldsList.forEach((formControl) => {
              this.myFormGroup.addControl(formControl.fieldName, this.formBuilder.control(''));
            });

            this.coreFieldList = this.coreFieldListForType;

            this.coreFieldList = this.coreFieldList.filter((s: any) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s: any) => s.rolePermission != 2);


            const Fields = {};
            this.coreFieldList.forEach((formControl: any) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl('', Validators.pattern(phoneNumberregex));
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl('', Validators.pattern(phoneNumberregex));
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            });

          }
          else {
          }
        }
      }
    });

  }

  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0] != undefined ? _newdropdownlist[0].value : "";
  }

  getMuldropdownlist(fieldName) {
    if (!this.multipleDropdownList || !Array.isArray(this.multipleDropdownList)) {
      return "";
    }

    const result = this.multipleDropdownList.filter(s => s.FieldValue === fieldName);
    return result.length > 0 ? result[0].value : "";
  }

  // getMuldropdownlist(fieldName) {
  //   var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
  //   return _newMuldropdownlist[0]!=undefined ? _newMuldropdownlist[0].value :"";
  // }


  getCheckBoxlist(fieldName) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    return _newcheckBoxlist[0] != undefined ? _newcheckBoxlist[0].value : "";
  }

  OnChange($event: any, chk: any, fieldId: any) {
    let ckhchecked = [];
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {
      this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
      });
    } else {
      if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
        this.chkStatusArry = this.chkStatusArry.filter(
          (item) =>
            item.ckh != chk
        );
      }
    }
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImageUploadURL = response.data;
        }
      }
    });
  }



  onSubmit(formValues, form) {
    this.spinner = true;
    this.myFormGroup.markAsPristine();

    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.TaskID = Number(this.taskId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      this.addCoreVm.FolderID = this.folderID;//17;
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                    (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL;
            }
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: frmctrl != undefined ? frmctrl.subfolderID : 0,
            ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });


      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,

      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      if (AddressDefault != undefined) {
        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["City"],
          "childFieldType": 3
        })

        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["State"],
          "childFieldType": 2
        })

        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["ZipCode"],
          "childFieldType": 4
        })

        AddressDefault.ChildFields.push({
          "id": 0,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["Country"],
          "childFieldType": 1
        })
      }
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/


      //
      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City" + i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State" + i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode" + i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country" + i],
          "childFieldType": 1
        })
        fieldList = fieldList.filter(function (value, index) {
          return index != indexDynamic;
        });
        fieldList.splice(indexDynamic, 0, AddressDynamic);

      });

      fieldList = fieldList.filter((x: any) => x !== undefined && x !== null);
      //********** */
      this.addCoreVm.ImageUrl = this.ImageUploadURL
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.Tags = this.tagvalues;
      this.addCoreVm.TypeID = Number(this.typeId) > 0 ? Number(this.typeId) : 0;
      this.addCoreVm.officeID = this.myOfficeID;
      this.addCoreVm.OfficeIDList = this.OfficeIDList;
      this.loaderService.show();
      //return;
      this.coreService.AddTaskCustomField(this.addCoreVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.spinner = false;
            this.closeListing(false);
            this.tags = [];
            this.myFormGroup.reset();
            //this.router.navigate(['/task']);
            this.IsCustomFieldExist = true;
            this.getCoreUserDetails();
            //this._dataSharingService.sendSaveUserForCore();
            this.toastr.success('Record save successfully.', '', {
              timeOut: 3000,
            });
          } else {
            this.spinner = false;
            this.loaderService.hide();
          }
        } else {
          this.spinner = false;
          this.loaderService.hide();
        }
      });
    }
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  closeListing(message: boolean) {
    this.ImageUploadURL = "";
    //this.getAllFolderFields();
    this.tags = [];
    this.closeAdd.emit(message);
    this.myFormGroup.reset();
  }

  //
  //#endregion

  //#region Edit Tasks Dynamic fields

  revertForm() {
    if (this.myFormGroup.dirty) {
      this.getCoreUserDetails();
      // this.getCoreUserDetailsforSubFolderId(); 
      this.myFormGroup.markAsPristine();
    }
  }
  SaveCoreUserDetails(formValues: any) {
    this.saveCoreDetails(formValues);
  }
  saveCoreDetails(formValues) {
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.TaskID = Number(this.taskId);//Number(this.transactionID);
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) => key.includes(m.fieldName));

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0
          });
        }
      }

      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      var checkcity = [];
      checkcity = this.arryaControlNameIdpare.filter(e => e.name == 'City');
      if (checkcity.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'City').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["City"],
          "childFieldType": 3
        });
      }
      var checkstate = [];
      checkstate = this.arryaControlNameIdpare.filter(e => e.name == 'State');
      if (checkstate.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'State').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["State"],
          "childFieldType": 2
        });
      }
      var checkzip = [];
      checkzip = this.arryaControlNameIdpare.filter(e => e.name == 'ZipCode');
      if (checkzip.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["ZipCode"],
          "childFieldType": 4
        });
      }
      var checkcountry = [];
      checkcountry = this.arryaControlNameIdpare.filter(e => e.name == 'Country');
      if (checkcountry.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'Country').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["Country"],
          "childFieldType": 1
        });
      }
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/

      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        if (AddressDynamic != undefined) {
          AddressDynamic.ChildFields.push({
            "id": cityctrl != undefined ? cityctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["City" + i],
            "childFieldType": 3
          })
          AddressDynamic.ChildFields.push({
            "id": statectrl != undefined ? statectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["State" + i],
            "childFieldType": 2
          })
          AddressDynamic.ChildFields.push({
            "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["ZipCode" + i],
            "childFieldType": 4
          })
          AddressDynamic.ChildFields.push({
            "id": countryctrl != undefined ? countryctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["Country" + i],
            "childFieldType": 1
          })

          fieldList = fieldList.filter(function (value, index) {
            return index != indexDynamic;
          });
          fieldList.splice(indexDynamic, 0, AddressDynamic);
        }
      });
      fieldList = fieldList.filter((x: any) => x !== undefined && x !== null);
      //********** */
      this.addCoreVm.ImageUrl = this.ImagePathURL
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addCoreVm.Tags = this.tagvalues;
      this.addCoreVm.officeID = this.myOfficeID;
      this.addCoreVm.OfficeIDList = this.OfficeIDList;
      this.loaderService.show();
      this.coreService.UpdateTaskCustomFields(this.addCoreVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            //sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());  
            this.loaderService.hide();
            this.myFormGroup.markAsPristine();
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
            this.getCoreUserDetails();
            //this.getCoreUserDetailsforSubFolderId();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '' && _newdropdownlist[0].selectedVal != undefined) {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '' && _newMuldropdownlist[0].selectedVal != undefined) {
        if (fieldName != "Tags") {
          return _newMuldropdownlist[0].selectedVal.split(',');
        } else {
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }

  getCoreUserDetailsOnTypeChange(event: any, fieldName: any) {
    this.transactionID;
    this.isTypeChanged = true;
    this.TypeIdDrp = parseInt(event.value);
    this.arryaControlNameIdpare = []
    this.arrayControlNameSubfolderID = [];
    this.getCoreUserDetails(true);
  }

  getAddressTypeFieldName(childFieldType) {
    if (childFieldType == 3)
      return 'City';
    if (childFieldType == 2)
      return 'State';
    if (childFieldType == 4)
      return 'ZipCode';
    if (childFieldType == 1)
      return 'Country';
  }

  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
    }
  }

  transactionIDForTask: number = 0;
  typeIdForTask: number = 1;
  NameForTask: string = "";
  EmailForTask: string = "";
  ImageForTask: string = "";

  getCoreUserDetails(isFromDDlType: boolean = false) {
    this.transactionIDForTask = Number(sessionStorage.getItem('transactionID'));
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.TaskID = Number(this.taskId);
    this.coreVm.FolderId = this.folderID;
    this.coreVm.subFolderID = Number(this.TypeIdDrp);
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    //this.loaderService.show();
    this.coreService.GetTaskCustomFields(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreUserList = response.data.fields;
          this.ImageForTask = response.data.imageUrl;
          var checkName = [];
          var checkEmail = [];
          checkName = response.data.fields.filter((x: any) => x.fieldName.toLowerCase() == "Name".toLowerCase());
          if (checkName.length > 0) {
            this.NameForTask = checkName[0].fieldValue;
            //this.transactionUserName = checkName[0].fieldValue;
            this.addByName = checkName[0].fieldValue;
          }
          checkEmail = response.data.fields.filter((x: any) => x.fieldName.toLowerCase() == "Email".toLowerCase());
          if (checkEmail.length > 0) {
            this.EmailForTask = checkEmail[0].fieldValue;
            this.addByEmail = checkEmail[0].fieldValue;
          }

          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, { folderName: "Select", isChecked: false, subFolderID: 0 });

          var TypeData = this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          if (TypeData != undefined && TypeData != '' && TypeData != null && isFromDDlType == false) {
            this.TypeIdDrp = Number(TypeData[0].fieldValue);
          }
          var taglist;
          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              var str = taglist[0].fieldValue;
              var selectedValues = str.replace(/^,|,$/g, '');
              this.tags = selectedValues.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          // var NewList;
          // NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          // if(type.length>0){
          //   NewList.splice(1, 0, type[0]);
          // } 
          // this.coreUserList = NewList;

          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray = [];
          let ArrayWithGroupedElement = [];
          this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2);
          this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);

          this.coreUserList.forEach((formControl) => {
            let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0).length;
            let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0);
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);
            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });

          this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldName == 'Name') {
              //this.transactionUserName = this.taskDetailList.title;            
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find((x) => x.fieldNameID == formControl.fieldNameID);
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }
          });
          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();

          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');

          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//17;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];
                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);
              }
            });

            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });

            this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {
                var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                value = drpValue.split(',');
                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }

            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });

          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          if (this.dynamicArrayTemp?.length) {
            this.dynamicArrayTemp.forEach((e, i) => {
              this.appendEle(e, 1, i + 1);
            });
          }
          if (this.dynamicArrayAddressTemp?.length) {
            this.dynamicArrayAddressTemp.forEach((e, i) => {
              this.appendEle(e, 2, i + 1);
            });
          }
          if (this.dynamicArrayPhoneTemp?.length) {
            this.dynamicArrayPhoneTemp.forEach((e, i) => {
              this.appendEle(e, 3, i + 1);
            });
          }
          if (this.dynamicArrayWebsiteTemp?.length) {
            if (this.dynamicArrayWebsiteTemp != undefined)
              this.dynamicArrayWebsiteTemp.forEach((e, i) => {
                this.appendEle(e, 4, i + 1);
              });
          }
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
        } else {
          this.coreUserList = [];
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        // if(chk.length==0){
        //   selectedVal="";
        // } 

        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp = this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if (drp.length > 0) {
          selectedVal = drp[0].fieldValue;
        }
        else {
          selectedVal = this.multipleDropdownList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        //  if(drp.length==0){
        //   selectedVal="";
        //  } 

        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal: selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }

  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {

        if (this.dropdownlist[i].defaultValue.length > 0) {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
          let drp = this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
          if (drp.length > 0) {
            selectedVal = drp[0].fieldValue;
          }
          else {
            selectedVal = this.dropdownlist[i].fieldValue
          }

          if (selectedVal == undefined || selectedVal == null) {
            selectedVal = "";
          }
          // if(drp.length==0){
          //   selectedVal="";
          //  }

          var FieldsDrp = {
            FieldValue: this.dropdownlist[i].fieldName,
            value: value,
            selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
          };
          fieldListdrp.push(FieldsDrp);
        }
      }
      this.dropdownlist = fieldListdrp;
    }
  }

  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  appendEle(field: any, type: any, index: any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);

    let addressRefactor: any = [];
    if (field.address != undefined && field.address.length > 0) {
      addressRefactor.push(field.address.find(x => x.childFieldType == 0));
      addressRefactor.push(field.address.find(x => x.childFieldType == 3));
      addressRefactor.push(field.address.find(x => x.childFieldType == 2));
      addressRefactor.push(field.address.find(x => x.childFieldType == 4));
    }

    // addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address: addressRefactor,
      isPrimary: field.isPrimary
    };


    //1 Email ,2 Address,3 Phone,4 website
    if (type == 2) {
      this.myFormGroup.addControl('City' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + index);
      this.addressFormGroup.push('City' + index);
      this.addressFormGroup.push('State' + index);
      this.addressFormGroup.push('ZipCode' + index);
      this.addressFormGroup.push('Country' + index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);
  }
  //#endregion







  //========= Schedule by anothe task ========//

  taskStatusListForSchedule: any = [];

  getTaskStatusForSchedule() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    //this.loaderService.show();
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusListForSchedule = this.responseHolder.data;
          this.taskStatusListForSchedule = this.taskStatusListForSchedule.filter((x: any) => x.taskStatusConstantName != 'open');
          var obj = {
            isActive: true,
            isCommon: true,
            taskStatusConstantName: "duedate",
            taskStatusID: 0,
            taskStatusName: "Due Date"
          }
          this.taskStatusListForSchedule.splice(0, 0, obj);
          this.getTaskDetailByID();
        }
        else {
          this.getTaskDetailByID();
          // this.loaderService.hide();
        }
      }
      else {
        this.getTaskDetailByID();
        //this.loaderService.hide();
      }
    });

  }

  getTaskStatusForSchedule1() {
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    //this.loaderService.show();
    this.coreService.taskStatus(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskStatusListForSchedule = this.responseHolder.data;
          this.taskStatusListForSchedule = this.taskStatusListForSchedule.filter((x: any) => x.taskStatusConstantName != 'open');
          var obj = {
            isActive: true,
            isCommon: true,
            taskStatusConstantName: "duedate",
            taskStatusID: 0,
            taskStatusName: "Due Date"
          }
          this.taskStatusListForSchedule.splice(0, 0, obj);
          this.getTaskByTaskList();
        }
        else {
          this.getTaskDetailByID();
        }
      }
      else {
        this.getTaskDetailByID();
      }
    });

  }

  SelectDependantTaskList: any = [] = [];
  SelectDependantTaskListFilter: any = [] = [];
  selectedtask: any = [] = [];
  dependentTaskID: number = 0;
  trigger: string = "";
  timenumber: number = 0;
  timeperiod: string = "";
  afterbefore: string = "";

  columns: any = [] = [];

  getTaskByTaskList() {
    var ReqModel = {
      taskListID: this.taskListID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId
    }
    this.coreService.GetTaskGroupsByTaskList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        // this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

          if (response.data.taskGroups !== undefined && response.data.taskGroups !== null) {
            response.data.taskGroups = response.data.taskGroups.sort(function (a, b) {
              return a.groupPosition - b.groupPosition;
            });

            response.data.taskGroups.forEach(tg => {

              if (tg.tasks !== undefined && tg.tasks !== null) {
                tg.tasks.forEach(ts => {
                  if (ts.taskId != this.taskId) {
                    var obj = {
                      taskListName: ts.taskTitle,
                      taskId: ts.taskId,
                      dueDate: ts.dueDate
                    }
                    this.SelectDependantTaskList.push(obj);
                  }
                  //ts.formLink=this.reSetFormURL(ts.taskId,ts.formLink);
                });
              }
            });
          }
          this.getTaskDetailByID();
        }
        else {
          this.getTaskDetailByID();
          this.SelectDependantTaskList = [];
        }
      }
      else {
        this.getTaskDetailByID();
        this.SelectDependantTaskList = [];
      }
    });
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  searchTask(searchValue: any) {
    if (this.taskListID > 0) {
      const filterValue = this._normalizeValue(searchValue);
      this.SelectDependantTaskListFilter = this.SelectDependantTaskList.filter((x: any) => x.taskListName.toLowerCase().includes(filterValue));
    }
  }

  depandantTaskDueDate: any;
  showSchTask: boolean = true;
  dueDatecheck: any;
  originalDueDate: any;
  IsClear: boolean = false;

  taskSelected(taskSelected: any) {
    this.clearTaskSch = false;
    this.dependentTaskID = taskSelected.taskId;
    this.depandantTaskDueDate = taskSelected.dueDate;
    this.myTaskForm.markAsDirty();
  }

  getStatusValForSchedule(e: any) {
    var check = [];
    check = this.taskStatusListForSchedule.filter((x: any) => x.taskStatusID == Number(e.value));
    if (check.length > 0) {
      this.trigger = check[0].taskStatusConstantName;
    }
  }

  Triggertask(e: any) {
    this.clearTaskSch = false;
    if (e.value == "intasklist") {
      this.showSchTask = false;
      this.myTaskForm.controls['dueDate'].setValue(this.originalDueDate);
    } else {
      this.showSchTask = true;
    }
  }

  onTimeNoChange(searchValue: number): void {
    this.clearTaskSch = false;
    // var dueDatecheck = this.myTaskForm.get('dueDate').value;

    var timeperiod = this.myTaskForm.get('timeperiod').value;
    if (timeperiod == "immediately") {
      this.myTaskForm.controls['afterbefore'].setValue('none');
      this.myTaskForm.controls['timenumber'].setValue(0);
      return;
    }
    //  if(this.dueDatecheck!=null){
    if (this.trigger == "duedate") {
      if (this.depandantTaskDueDate != null) {
        if (this.afterbefore == "after") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate() +1);
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() + numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            //const weeks = new Date(this.depandantTaskDueDate);
            weeks.setDate(weeks.getDate());
            // weeks.setDate(weeks.getDate() +1);
            var result1 = weeks.setDate(weeks.getDate() + numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }

        if (this.afterbefore == "before") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate());
            //dates.setDate(dates.getDate() +1);
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() - numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            // const weeks = new Date(this.depandantTaskDueDate);
            //  weeks.setDate(weeks.getDate());
            // weeks.setDate(weeks.getDate()+1);
            var result1 = weeks.setDate(weeks.getDate() - numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }
      }
      //}
    }

  }


  selectTimePeriod(e: any) {
    this.clearTaskSch = false;
    // var dueDatecheck = this.myTaskForm.get('dueDate').value;

    this.timeperiod = e.value;
    if (this.timeperiod == "immediately") {
      this.myTaskForm.controls['afterbefore'].setValue('none');
      this.myTaskForm.controls['timenumber'].setValue(0);
      return;
    }
    // if(this.dueDatecheck!=null){
    if (this.trigger == "duedate") {
      if (this.depandantTaskDueDate != null) {
        if (this.afterbefore == "after") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate());
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() + numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            // weeks.setDate(weeks.getDate());
            var result1 = weeks.setDate(weeks.getDate() + numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }

        if (this.afterbefore == "before") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate());
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() - numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            // weeks.setDate(weeks.getDate());
            var result1 = weeks.setDate(weeks.getDate() - numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }
      }
      //  }
    }

  }

  selectAfterBefore(e: any) {
    this.clearTaskSch = false;
    this.afterbefore = e.value;

    //var dueDatecheck = this.myTaskForm.get('dueDate').value;

    var timeperiod = this.myTaskForm.get('timeperiod').value;
    if (timeperiod == "immediately") {
      this.myTaskForm.controls['afterbefore'].setValue('none');
      this.myTaskForm.controls['timenumber'].setValue(0);
      return;
    }

    // if(this.dueDatecheck!=null){
    if (this.trigger == "duedate") {
      if (this.depandantTaskDueDate != null) {
        if (this.afterbefore == "after") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate());
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() + numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            // weeks.setDate(weeks.getDate());
            var result1 = weeks.setDate(weeks.getDate() + numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }

        if (this.afterbefore == "before") {
          if (this.myTaskForm.get('timeperiod').value == "days") {
            var days = this.myTaskForm.get('timenumber').value;
            var dates = new Date(this.depandantTaskDueDate);
            // dates.setDate(dates.getDate());
            var numberOfDaysToAdd = Number(days);
            var result = dates.setDate(dates.getDate() - numberOfDaysToAdd);
            this.myTaskForm.controls['dueDate'].setValue(dates);
          }
          if (this.myTaskForm.get('timeperiod').value == "weeks") {
            var days = this.myTaskForm.get('timenumber').value;
            const numWeeks = Number(days);
            const weeks = new Date(this.depandantTaskDueDate);
            // weeks.setDate(weeks.getDate());
            var result1 = weeks.setDate(weeks.getDate() - numWeeks * 7);
            this.myTaskForm.controls['dueDate'].setValue(weeks);
          }
        }
      }
      // }
    }

  }

  clearDate(event: any) {
    event.stopPropagation();
    this.myTaskForm.controls['dueDate'].setValue(null);
    this.myTaskForm.markAsDirty();
  }

  dateHasValue() {
    return this.myTaskForm.controls['dueDate'].value;
  }

  numberOnlyForSch(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  clearTaskSch: boolean = false;

  clearTaskSchedule() {
    this.trigger = "";
    this.clearTaskSch = true;
    this.taskListName = "";
    this.dependentTaskID = 0;
    this.myTaskForm.controls['timeperiod'].setValue(null);
    this.myTaskForm.controls['timenumber'].setValue(null);
    this.myTaskForm.controls['afterbefore'].setValue(null);
    this.myTaskForm.controls['triggertask'].setValue(null);
    this.myTaskForm.controls['triggerstatus'].setValue(null);
    //this.myTaskForm.controls['dueDate'].setValue(null);
    this.myTaskForm.markAsDirty();
  }



  ShowWeeks: boolean = false;
  ShowMonths: boolean = false;
  ShowYears: boolean = false;
  EndOnDate: boolean = false;
  Occurence: boolean = false;

  Sundaychecked: boolean = false;
  Mondaychecked: boolean = false;
  Tuesdaychecked: boolean = false;
  Wednesdaychecked: boolean = false;
  Thursdaychecked: boolean = false;
  Fridaychecked: boolean = false;
  Saturdaychecked: boolean = false;

  Sunday: string = "";
  Monday: string = "";
  Tuesday: string = "";
  Wednesday: string = "";
  Thursday: string = "";
  Friday: string = "";
  Saturday: string = "";
  neverChecked: boolean = true;
  onChecked: boolean = false;
  afterChecked: boolean = false;

  selectRepeat(e: any) {
    if (e.value == 'week') {
      this.ShowWeeks = true;
      this.ShowMonths = false;
      this.ShowYears = false;
    }
    if (e.value == 'month') {
      this.ShowMonths = true;
      this.ShowWeeks = false;
      this.ShowYears = false;
    }
    if (e.value == 'year') {
      this.ShowMonths = false;
      this.ShowWeeks = false;
      this.ShowYears = true;
    }
  }

  neverChange(event: MatRadioChange) {
    this.EndOnDate = true;
    this.Occurence = true;

    this.neverChecked = true;
    this.onChecked = false;
    this.afterChecked = false;
    this.myTaskForm.controls['EndsOnDate'].setValue(null);
    this.myTaskForm.controls['occurances'].setValue(null);
  }

  onChanges(event: MatRadioChange) {
    this.EndOnDate = false;
    this.Occurence = true;

    this.neverChecked = false;
    this.onChecked = true;
    this.afterChecked = false;
    this.myTaskForm.controls['occurances'].setValue(null);
  }

  afterChanges(event: MatRadioChange) {
    this.EndOnDate = true;
    this.Occurence = false;

    this.neverChecked = false;
    this.onChecked = false;
    this.afterChecked = true;
    this.myTaskForm.controls['EndsOnDate'].setValue(null);
  }

  SundayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Sundaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Sunday = "Sunday";
    } else {
      this.Sunday = "";
    }
  }

  MondayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Mondaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Monday = "Monday";
    } else {
      this.Monday = "";
    }
  }

  TuesdayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Tuesdaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Tuesday = "Tuesday";
    } else {
      this.Tuesday = "";
    }
  }

  WednesdayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Wednesdaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Wednesday = "Wednesday";
    } else {
      this.Wednesday = "";
    }
  }

  ThursdayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Thursdaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Thursday = "Thursday";
    } else {
      this.Thursday = "";
    }
  }

  FridayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Fridaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Friday = "Friday";
    } else {
      this.Friday = "";
    }
  }

  SaturdayClicked(values: any): void {
    this.myTaskForm.markAsDirty();
    this.Saturdaychecked = values.currentTarget.checked;
    if (values.currentTarget.checked == true) {
      this.Saturday = "Saturday";
    } else {
      this.Saturday = "";
    }
  }



  showFieldBased: boolean = false;

  showFieldBasedDropdonw: boolean = false;
  FieldBasedDateDropDown: any = [] = [];
  nextDueDate: string = "";
  // Repeat Task

  changeRepeatingTask(e) {
    if (e.value == "Basic Repeating Task") {
      this.showFieldBasedDropdonw = false;
    }
    if (e.value == "Field Based Repeating Task") {
      this.showFieldBasedDropdonw = true;
      this.FieldBasedDateDropDown = [];
      // this.getCoreUserDetailsForFeildBased();
      this.getSynonyms();
    }
  }

  folderIdsCCC: number = 0;
  FieldID: number = 0;
  BasicRepeatingTask: boolean = true;
  FieldBasedRepeatingTask: boolean = false;

  getCoreUserDetailsForFeildBased() {
    this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
    if (this.mainModulename == "Core") {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Core");
      this.folderIdsCCC = data[0].folderID;
    }
    if (this.mainModulename == "Contact") {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Contact");
      this.folderIdsCCC = data[0].folderID;
    }
    if (this.mainModulename == "Company") {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Company");
      this.folderIdsCCC = data[0].folderID;
    }
    var obj = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      coreID: Number(sessionStorage.getItem('transactionID')),
      folderId: Number(this.folderIdsCCC),
      subFolderID: Number(this.TypeIdDrp),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    }
    this.loaderService.show();
    this.coreService.getCoreUserDetails(obj).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var NewList = [];
          NewList = response.data.fields.filter((s) => s.fieldTypeName == 'Date');
          this.FieldBasedDateDropDown = NewList;

          this.loaderService.hide();

        } else {

        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  getSynonyms() {
    this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
    if (this.checkedAttachCore == true) {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Core");
      this.folderIdsCCC = data[0].folderID;
    }
    if (this.checkedAttachContact == true) {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Contact");
      this.folderIdsCCC = data[0].folderID;
    }

    if (this.checkedAttachCompany == true) {
      var data = this.folderList.filter((x: any) => x.mainModuleName === "Company");
      this.folderIdsCCC = data[0].folderID;
    }

    var obj = {
      isSearch: false,
      fieldName: "",
      folderID: this.folderIdsCCC,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID
    }
    this.loaderService.show();
    this.settingsService.searchFieldName(obj).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var NewList = [];
          // NewList = response.data.fields.filter((s) => s.fieldTypeName == 'Date');
          NewList = response.data.filter((s) => s.fieldTypeName == 'Date');
          this.FieldBasedDateDropDown = NewList;
          this.loaderService.hide();
        } else {
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  getDrpFields(event: { value: number; }) {
    if (event != undefined) {
      if (this.FieldBasedDateDropDown.length > 0) {
        this.FieldID = event.value;
        var check = [];
        check = this.FieldBasedDateDropDown.filter((x: any) => x.fieldID == event.value);
        if (check.length > 0) {
          this.nextDueDate = check[0].fieldValue;
          if (this.nextDueDate != undefined) {
            const d = new Date(this.nextDueDate);
            // This will return an ISO string matching your local time.
            var dueDateNew = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() - d.getTimezoneOffset()).toISOString();
            this.myTaskForm.controls['dueDate'].setValue(dueDateNew);
          }
        }
      }
    }
  }


  DueOnCreationCheckbox(event: MatCheckboxChange): void {
    this.FieldID = 0;
    if (event.checked == true) {
      this.showFieldBasedDropdonw = false;
      this.myTaskForm.controls['isDueDateTrigger'].setValue(true);
      this.myTaskForm.controls['isDueOnFieldBased'].setValue(false);
    } else {
      this.myTaskForm.controls['isDueDateTrigger'].setValue(false);
    }
  }


  DueOnFieldBasedCheckbox(event: MatCheckboxChange): void {
    if (event.checked == true) {
      this.showFieldBasedDropdonw = true;
      this.myTaskForm.controls['isDueDateTrigger'].setValue(false);
      this.myTaskForm.controls['isDueOnFieldBased'].setValue(true);
    } else {
      this.FieldID = 0;
      this.showFieldBasedDropdonw = false;
      this.myTaskForm.controls['isDueOnFieldBased'].setValue(false);
    }
  }

  onRepeatTaskEmailChange(searchValue: string): void {
    if (searchValue.length == 0) {
      this.filtersFormArrayNotification.value.length = 0;
      this.dynamicFormNotification = this.formBuilder.group({
        filtersmNotification: this.formBuilder.array([])
      });
      this.showRepeatTaskEmail = false;
    }
  }

  onEmailTemplateChange(searchValue: string): void {
    if (searchValue.length == 0) {
      this.filtersFormArrayNotificationEmail.value.length = 0;
      this.dynamicFormNotificationEmail = this.formBuilder.group({
        filtersmNotificationEmail: this.formBuilder.array([])
      });
      this.showRepeatTaskEmail = false;
    }
  }
  //============== Template Email ==================//
  emailTemplateList: any = [] = [];


  // For Get All Template List
  getEmailTemplateList() {
    var ReqModel = {
      emailTemplateID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getAllEmailTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.emailTemplateList = this.responseHolder.data;
        } else {
        }
      } else {
      }
    });
  }

  formType: number = 0;
  selectedFormId: number = 0;
  Selected3cType: any = 0;
  signNowUrl: string = "";

  signNow(token: any, form: any) {

    const urlParams = new URLSearchParams(new URL(token).search);
    var newToken = urlParams.get('token');
    //var params = decodeURIComponent(newToken);

    let params = decodeURIComponent(newToken);
    const decryptedTokenString = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(decryptedTokenString)
    let objModel = {
      "OfficeID": decryptedToken.OfficeID,
      "IsReadOnlyFromSentPage": false,
      "ProjectID": decryptedToken.FormID,
      "FormID": decryptedToken.FormID,
      "CoreID": 0,
      "CorePlaceholderID": 0,
      "DocumentHtmls": "",
      "participantJsonList": "",
      "documentFolderID": 0,
      "email": "",
      "DatabaseID": decryptedToken.DatabaseID,
      "OrganizationID": decryptedToken.OrganizationID,
      "UserID": decryptedToken.UserID
    };
    let jsonStringToken = JSON.stringify(objModel);
    newToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonStringToken);
    newToken = encodeURIComponent(newToken);

    //1pdf 2 tabular 3 html{
    let url = '';
    if (form.formType == 1 || form.formType == 0)
      url = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + newToken + "&type=1" + "&signnowFrom=" + encodeURIComponent(this.LoggedInEmailId);
    else if (form.formType == 2)
      url = window.location.href.split(window.location.pathname)[0] + "/request/tabularsignature?token=" + newToken + "&type=1";
    return url
  }

  OpenFromActionFormType: boolean = false;

  OpenFormPopup() {
    if (this.projectID == 0) {
      const dialogRef = this.dialog.open(ImportForm3CListComponent, {
        data: {
          moduleName: "Task",
          panelClass: 'task_template',
          projectId: 0
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != null && result != undefined) {
          this.myTaskForm.controls['formLink'].setValue(result.url);
          this.myTaskForm.controls['formLinkFormName'].setValue(result.name);
          this.currentFormLinkFormName = result.name;
          this.formType = result.formType;
          this.disableFormLink = false;
          this.signNowUrl = result.signNowUrl;

          this.OpenFromActionFormType = true;
          this.filtersFormArray.controls = [];
          // this.filtersFormArrayNotification.controls=[];
          this.filtersFormArrayNotificationEmail.controls = [];
          this.updateTaskDetail(this.myTaskForm.value);
        }
      });
    } else {
      const message = `Project is allready created,are you sure you want to reset the Project?`;
      const title = `Confirm`;
      const confirm = `Confirm`;
      const dialogData = new ConfirmDialogModel(title, message, confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {
            const dialogRef = this.dialog.open(ImportForm3CListComponent, {
              data: {
                moduleName: "Task",
                panelClass: 'task_template',
                projectId: this.projectID
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result != null && result != undefined) {
                this.myTaskForm.controls['formLink'].setValue(result.url);
                this.myTaskForm.controls['formLinkFormName'].setValue(result.name);
                this.currentFormLinkFormName = result.name;
                this.formType = result.formType;
                this.disableFormLink = false;
                this.signNowUrl = result.signNowUrl;

                this.OpenFromActionFormType = true;
                this.resetTaskProject();
              }
            });
          }
        } catch (e) {
          Observable.throw(e);
        }
      });
    }
  }

  createProject() {
    const url = this.myTaskForm.controls['formLink'].value;
    const urlParams = new URLSearchParams(new URL(url).search);
    var newToken = urlParams.get('token');
    var params = decodeURIComponent(newToken);
    const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    let decryptedToken = JSON.parse(tokenm);
    // this.Selected3cType = decryptedToken.Selected3cType;
    // if(this.Selected3cType==undefined){
    //   this.Selected3cType=1;
    // }
    this.selectedFormId = decryptedToken.FormID;
    const dialogRef = this.dialog.open(AddSelectParticipantComponent, {
      data: {
        moduleName: "Task",
        formID: this.selectedFormId,
        TaskID: this.taskId,
        Selected3cType: this.entityTypeAttached,
        projectID: Number(this.projectID)
      },
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getTaskDetailByID();
      }
    });
  }


  resetTaskProject() {
    var ReqModel = {
      taskId: Number(this.taskId),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.resetTaskProject(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.updateTaskDetail(this.myTaskForm.value);
        } else {
        }
      } else {
      }
    });
  }

  getFileExtension(path: string): string {
    if (!path) {
      return '';
    }

    const cleanPath = path.split('?')[0]; // Remove query params if any
    return cleanPath.substring(cleanPath.lastIndexOf('.') + 1).toLowerCase();
  }

  specificDays: any = [] = [];

  specificDay: number = 0;

  addSpecificDay(): void {
    const value = this.myTaskForm.get('specificDay')?.value;

    if (value == null || value < 1) {
      this.toastr.warning('Please enter a valid day.');
      return;
    }

    const day = Number(value);

    if (this.specificDays.includes(day)) {
      this.toastr.warning('Record already added.');
      return;
    }

    this.specificDays.push(day);

    this.myTaskForm.get('specificDay')?.reset();
  }

  /** Allow only Number */
  allowOnlyNumber(event: any) {
    const regexp = new RegExp('^([0-9])$');
    const result = regexp.test(event.key);
    if (!result) {
      event.preventDefault();
      return false;
    }
  }

  removeDay(day: number, event: Event): void { 
     event.stopPropagation();
     this.specificDays = this.specificDays.filter((item: number) => item !== day);
     }
}
